// ***** PRODUCT FORM - DROPDOWN (FLOAT) ***** //

function product_form__dropdown_float__open(id) {
	// if closed
	if(!$('#pf-dd-f--' + id).hasClass('open')) {
		// open
		$('#pf-dd-f--' + id).addClass('open');
	}
}

function product_form__dropdown_float__close(id) {
	// if open
	if($('#pf-dd-f--' + id).hasClass('open')) {
		// close
		$('#pf-dd-f--' + id).removeClass('open');
	}
}

function product_form__dropdown_float__toggle(id) {
	// if closed
	if(!$('#pf-dd-f--' + id).hasClass('open')) {
		// open
		$('#pf-dd-f--' + id).addClass('open');
	}
	// if open
	else {
		// close
		$('#pf-dd-f--' + id).removeClass('open');
	}
}

function product_form__dropdown_float__select(id, val) {
	// var now = new Date().getTime();
	// console.log( now, 'product_form__dropdown_float__select', id, val );
	// set value
	$('#pf-dd-f--' + id + '--sel').html(val);
	// close
	product_form__dropdown_float__close(id);
}

function to_digits(input, digits, char) {
	char = char || '0';
	input = input + '';
	return input.length >= digits ? input : new Array(digits - input.length + 1).join(char) + input;
}

function pdp_bis_timestamp() {
	var d = new Date();
	// UTC
	var year = d.getUTCFullYear();
	var month = to_digits((d.getUTCMonth() + 1), 2);
	var day = to_digits(d.getUTCDate(), 2);
	var hr = to_digits(d.getUTCHours(), 2);
	var min = to_digits(d.getUTCMinutes(), 2);
	var sec = to_digits(d.getUTCSeconds(), 2);
	// PREP
	var output = '';
	output += year;
	output += '-';
	output += month;
	output += '-';
	output += day;
	output += ' ';
	output += hr;
	output += ':';
	output += min;
	output += ':';
	output += sec;
	// SET
	console.log( 'pdp_bis_timestamp()', output );
	return output;
}

function pdp_bis_form(form) {
	console.log( `pdp_bis_form()` );
	// generate timestamp
	var now = pdp_bis_timestamp();
	// reset datetime value to now
	jQuery(form).find('[data-timestamp]').val(now);
	// copy input email value to field in outside form
	jQuery(form).find('[data-pdp-bis-form-email-hidden]').val(
		jQuery(form).closest('.product-form').find('[data-pdp-bis-form-email-value]').val()
	);
	// complete
	return true;
}

/*

function pdp_oos_notify_form_input(e, elem) {
	console.log( `pdp_oos_notify_form_input()` );
	// console.log( 'e', e );
	// console.log( 'elem', elem );
	// if Enter key
	if(e.keyCode == 13) {
		pdp_oos_notify_form_button(elem);
	}
}

function pdp_oos_notify_form_button(elem) {
	console.log( `pdp_oos_notify_form_button()` );
	console.log( 'elem', elem );
	// copy input email value to field in outside form
	jQuery(elem).closest('.product-form').find('[data-pdp-bis-form-email-value]').val(
		jQuery(elem).closest('.product-form').find('pdp-bis-form-field-input').val()
	);
	// submit outside form
	// pdp_bis_form(
	// 	jQuery(elem).closest('.product-form').find('form.pdp-oos-notify-form')
	// );
	// generate timestamp
	var now = pdp_bis_timestamp();
	// reset datetime value to now
	jQuery(elem).closest('.product-form').find('form.pdp-oos-notify-form').find('[data-timestamp]').val(now);
	// submit
	jQuery(elem).closest('.product-form').find('form.pdp-oos-notify-form').submit();
}

*/

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //

// **************************************************************** //
// ZIPCODE GATEWAY
// **************************************************************** //

// no cookie value
function zipcode_gateway_none_pdp(form) {
	console.log( 'zipcode_gateway_none_pdp()' );
	// disable add to cart form
	zipcode_gateway_atc_disable_pdp(jQuery(form).parent().parent().get(0));
}

// **************************************************************** //

// preload cookie value
function zipcode_gateway_load_pdp(form) {
	console.log( 'zipcode_gateway_load_pdp()' );
	// pre-populate zipcode value
	jQuery(form).find('[name="zipcode"]').val(fec_zcg.c);
	jQuery(form).find('[data-zipcode-val]').text(fec_zcg.c);
}

// **************************************************************** //

// render pass
function zipcode_gateway_pass_pdp(form, z) {
	console.log( 'zipcode_gateway_pass_pdp()' );
	// set zipcode value
	jQuery(form).find('[data-zipcode-val]').text(z);
	// hide active msg
	jQuery(form).find('.product-form--zipcode--msg').removeClass('active');
	// show pass msg
	jQuery(form).find('.msg-pass').addClass('active');
	// remove zipcode gateway restriction
	zipcode_gateway_atc_enable_pdp(jQuery(form).parent().parent().get(0));
}

// **************************************************************** //

// render fail
function zipcode_gateway_fail_pdp(form, z) {
	console.log( 'zipcode_gateway_fail_pdp()' );
	// set zipcode value
	jQuery(form).find('[data-zipcode-val]').text(z);
	// hide active msg
	jQuery(form).find('.product-form--zipcode--msg').removeClass('active');
	// show fail text
	jQuery(form).find('.msg-fail').addClass('active');
	// add zipcode gateway restriction
	zipcode_gateway_atc_disable_pdp(jQuery(form).parent().parent().get(0));
}

// **************************************************************** //

function zipcode_gateway_atc_enable_pdp(container) {
	console.log( 'zipcode_gateway_atc_enable_pdp()' );
	// remove zipcode gateway restriction
	if(jQuery(container).hasClass('zipcodegateway')) {
		jQuery(container).removeClass('zipcodegateway');
	}
	/*
	// enable button
	jQuery(container).find('[data-pdp-atc]').prop('disabled', false);
	// correct form
	console.log( `jQuery(container).find('[data-pdp-form]').data('action-default')`, jQuery(container).find('[data-pdp-form]').data('action-default') );
	console.log( `jQuery(container).find('[data-pdp-form]').data('onsubmit-default')`, jQuery(container).find('[data-pdp-form]').data('onsubmit-default') );
	jQuery(container).find('[data-pdp-form]').attr('action', jQuery(container).find('[data-pdp-form]').data('action-default'));
	jQuery(container).find('[data-pdp-form]').attr('onsubmit', jQuery(container).find('[data-pdp-form]').data('onsubmit-default'));
	*/
}

function zipcode_gateway_atc_disable_pdp(container) {
	console.log( 'zipcode_gateway_atc_disable_pdp()' );
	// add zipcode gateway restriction
	if(!jQuery(container).hasClass('zipcodegateway')) {
		jQuery(container).addClass('zipcodegateway');
	}
	/*
	// disable button
	// console.log( `jQuery(container).find('[data-pdp-atc]')`, jQuery(container).find('[data-pdp-atc]') );
	jQuery(container).find('[data-pdp-atc]').prop('disabled', true);
	// break form
	// console.log( `jQuery(container).find('[data-pdp-form]')`, jQuery(container).find('[data-pdp-form]') );
	jQuery(container).find('[data-pdp-form]').removeAttr('action');
	jQuery(container).find('[data-pdp-form]').attr('onsubmit', 'event.preventDefault(); return false;');
	*/
}

// initialize
function zipcode_gateway_init(container, none, load, pass, fail) {
	var form = jQuery(container).find('.product-form--zipcode--form');
	console.log( 'zipcode_gateway_init()' );
	// if zip code is not set within cookie (undefined)
	if(!fec_zcg.c) {
		// set load state: no cookie value
		if(typeof none == 'function') {
			console.log( 'zipcode_gateway_init() > CALLING: none()' );
			none(form);
		}
		else {
			console.log( 'zipcode_gateway_init() > CALLING: zipcode_gateway_none_pdp()' );
			zipcode_gateway_none_pdp(form);
		}
	}
	// if zip code is set within cookie (not undefined)
	else {
		// set load state: has cookie value
		if(typeof load == 'function') {
			console.log( 'zipcode_gateway_init() > CALLING: load()' );
			load(form);
		}
		else {
			console.log( 'zipcode_gateway_init() > CALLING: zipcode_gateway_load_pdp()' );
			zipcode_gateway_load_pdp(form);
		}
		// render
		console.log( 'zipcode_gateway_init() > CALLING: zipcode_gateway_render()' );
		zipcode_gateway_render(fec_zcg, form, pass, fail);
	}
}


// render (have zipcode value: call `pass()` or `fail()`)
function zipcode_gateway_render(cookie, form, pass, fail) {
	console.log( 'zipcode_gateway_render()' );
	
	var cookie_found = false;
	
	if(typeof cookie == 'object') {
		if(cookie && !jQuery.isEmptyObject(cookie)) {
			cookie_found = true;
		}
	}
	
	if(cookie_found) {
		var fec_zcg = cookie;
	}
	else {
		var all_cookies = cookiesParse();
		var fec_zcg = cookieDecode(all_cookies.fec_zcg);
	}
	
	// *** obtain new zipcode value *** //
	
	var z = zipcode_gateway_check(form, true);
	
	// *** update cookie *** //
	
	var updated_fec_zcg = fec_zcg;
	
	// cookie: set zip code value
	updated_fec_zcg.c = z;
	// cookie: set product ID
	updated_fec_zcg.i = jQuery(form).find('[name="product-id"]').val();
	// cookie: set product handle
	updated_fec_zcg.h = jQuery(form).find('[name="product-handle"]').val();
	// cookie: increment n
	updated_fec_zcg.n = updated_fec_zcg.n + 1;
	// cookie: set timestamp
	updated_fec_zcg.z = Math.round(new Date().getTime() / 1000);
	
	// cookie: write updated cookie
	var confirm_fec_zcg_life = (fec_zcg_life) ? fec_zcg_life : 60;
	cookieSet('fec_zcg', cookieEncode(updated_fec_zcg), confirm_fec_zcg_life);
	
	// *** execute `pass()` or `fail()` callbacks //
	
	console.log( 'zipcode_gateway_render() > CALLING: zipcode_gateway_check()' );
	if(zipcode_gateway_check(form)) {
		// activate state: pass
		if(typeof pass == 'function') {
			console.log( 'zipcode_gateway_render() > CALLING: pass()' );
			pass(form, z);
		}
		else {
			console.log( 'zipcode_gateway_render() > CALLING: zipcode_gateway_pass_pdp()' );
			zipcode_gateway_pass_pdp(form, z);
		}
	}
	// if fail
	else {
		// activate state: fail
		if(typeof fail == 'function') {
			console.log( 'zipcode_gateway_render() > CALLING: fail()' );
			fail(form, z);
		}
		else {
			console.log( 'zipcode_gateway_render() > CALLING: zipcode_gateway_fail_pdp()' );
			zipcode_gateway_fail_pdp(form, z);
		}
	}
	
}

// check if zipcode value (needle) is within zipcode gateway zone zipcodes array (haystack)
function zipcode_gateway_check(form, return_input) {
	console.log( 'zipcode_gateway_check()' );
	
	// *** GET ZIPCODE ZONE ZIPCODES (HAYSTACK) *** //
	
	var zipcodes = jQuery(form).find('[name="zipcode-delivery-zone-zipcodes"]').val().trim().split(',');
	// console.log( `zipcodes`, zipcodes );
	
	// *** VALIDATE INPUT *** //
	
	var validated = false;
	var z = jQuery(form).find('[name="zipcode"]').val().toString();
	// strip whitespace
	z = z.trim();
	// error prevention
	if(z == null || z == '') {
		z = '0';
	}
	// validate
	if(
		z != null
		&&
		z != ''
		&&
		parseInt(z) > 0
		&&
		z.length == 5
	) {
		validated = true;
	}
	
	// *** CHECK FOR NEEDLE IN HAYSTACK *** //
	
	var zipcode_pass = false;
	
	if(
		validated
		&&
		jQuery.inArray(z, zipcodes) > -1
	) {
		zipcode_pass = true;
	}
	
	// *** //
	
	if(return_input) {
		return z;
	}
	else {
		if(zipcode_pass) {
			return true;
		}
		else {
			return false;
		}
	}
	
}


function zipcode_gateway_submit(e, form, pass, fail) {
	console.log( 'zipcode_gateway_submit()' );
	// prevent default form submission (page reload)
	e.preventDefault();
	// render
	console.log( 'zipcode_gateway_submit() > CALLING: zipcode_gateway_render()' );
	zipcode_gateway_render(false, form, pass, fail);
	// exit
	return false;
}

// **************************************************************** //
// AGE GATEWAY
// **************************************************************** //

// preload cookie value
function age_gateway_load_pdp(checkbox) {
	// console.log( `age_gateway_load_pdp(checkbox)`, checkbox );
	// pre-check agegate checkbox
	// console.log( 'PRE-CHECK AGE GATE CHECKBOX' );
	jQuery(checkbox).prop('checked', true);
}

// render pass
function age_gateway_pass_pdp(container) {
	// console.log( `age_gateway_pass_pdp(container)`, container );
	// remove age gateway restriction
	// console.log( 'REMOVE AGE GATEWAY RESTRICTION' );
	age_gateway_atc_enable_pdp(container);
}

// render fail
function age_gateway_fail_pdp(container) {
	// console.log( `age_gateway_fail_pdp(container)`, container );
	// add age gateway restriction
	// console.log( 'ADD AGE GATEWAY RESTRICTION' );
	age_gateway_atc_disable_pdp(container);
}

function age_gateway_atc_enable_pdp(container) {
	// console.log( `age_gateway_atc_enable_pdp(container)`, container );
	// remove age gateway restriction
	if(jQuery(container).hasClass('agegateway')) {
		// console.log( 'REMOVED CONTAINER CLASS `agegateway`' );
		jQuery(container).removeClass('agegateway');
		console.log('Remove age gateway restriction.');
	}
	// console.log( '(CONTAINER CLASS `agegateway` ALREADY REMOVED)' );
}

function age_gateway_atc_disable_pdp(container) {
	// console.log( `age_gateway_atc_disable_pdp(container)`, container );
	// add age gateway restriction
	if(!jQuery(container).hasClass('agegateway')) {
		// console.log( 'ADDED CONTAINER CLASS `agegateway`' );
		jQuery(container).addClass('agegateway');
		console.log('Add age gateway restriction.');
	}
	// console.log( '(CONTAINER CLASS `agegateway` ALREADY ADDED)' );
}

// initialize
function age_gateway_init(container) {
	// console.log( `age_gateway_init(container)`, container );
	var checkbox = jQuery(container).find('[data-agegate-checkbox]').get(0);
	// if age gateway is set to passing value within cookie
	if(fec_ag.c == 'y') {
		console.log('Cookie value found: fec_ag: pass');
		// set load state: pass
		age_gateway_load_pdp(checkbox);
		// pass
		age_gateway_pass_pdp(container);
	}
	// if no passing value is set within cookie
	else {
		// pass
		age_gateway_fail_pdp(container);
	}
}

function age_gateway_pass_cookie(form) {
	// console.log( `age_gateway_pass_cookie(form)`, form );
	
	var cookie_found = false;
	
	if(typeof fec_ag == 'object') {
		if(fec_ag && !jQuery.isEmptyObject(fec_ag)) {
			cookie_found = true;
		}
	}
	
	if(!cookie_found) {
		var all_cookies = cookiesParse();
		var fec_ag = cookieDecode(all_cookies.fec_ag);
	}
	
	// *** update cookie *** //
	
	var updated_fec_ag = fec_ag;
	
	// cookie: set passing value
	updated_fec_ag.c = 'y';
	// cookie: set product ID
	updated_fec_ag.i = jQuery(form).find('[name="product-id"]').val();
	// cookie: set product handle
	updated_fec_ag.h = jQuery(form).find('[name="product-handle"]').val();
	// cookie: increment n
	updated_fec_ag.n = updated_fec_ag.n + 1;
	// cookie: set timestamp
	updated_fec_ag.z = Math.round(new Date().getTime() / 1000);
	
	// cookie: write updated cookie
	var confirm_fec_ag_life = (fec_ag_life) ? fec_ag_life : 60;
	cookieSet('fec_ag', cookieEncode(updated_fec_ag), confirm_fec_ag_life);
	
	console.log( 'Cookie set: fec_ag: pass');
}

function age_gateway_fail_cookie(form) {
	// console.log( `age_gateway_pass_cookie(form)`, form );
	
	var cookie_found = false;
	
	if(typeof fec_ag == 'object') {
		if(fec_ag && !jQuery.isEmptyObject(fec_ag)) {
			cookie_found = true;
		}
	}
	
	if(!cookie_found) {
		var all_cookies = cookiesParse();
		var fec_ag = cookieDecode(all_cookies.fec_ag);
	}
		
	var updated_fec_ag = fec_ag;
	
	// cookie: set failing value
	updated_fec_ag.c = 'n';
	// cookie: set product ID
	updated_fec_ag.i = jQuery(form).find('[name="product-id"]').val();
	// cookie: set product handle
	updated_fec_ag.h = jQuery(form).find('[name="product-handle"]').val();
	// cookie: increment n
	updated_fec_ag.n = updated_fec_ag.n + 1;
	// cookie: set timestamp
	updated_fec_ag.z = Math.round(new Date().getTime() / 1000);
	
	// cookie: write updated cookie
	var confirm_fec_ag_life = (fec_ag_life) ? fec_ag_life : 60;
	cookieSet('fec_ag', cookieEncode(updated_fec_ag), confirm_fec_ag_life);
	
	console.log( 'Cookie set: fec_ag: fail');
}

// checkbox onchange event
function age_gateway_set(checkbox) {
	// console.log( `age_gateway_set(checkbox)`, checkbox );
	var container = jQuery(checkbox).closest('.product-form');
	var form = jQuery(checkbox).closest('.product-form').find('form.pdp-form');
	// if checkbox is checked (age verification passed)
	if(jQuery(checkbox).prop('checked') === true) {
		// set pass
		age_gateway_pass_pdp(container);
		// set cookie: pass
		age_gateway_pass_cookie(form);
	}
	// if checkbox is unchecked (age verification failed)
	else {
		// set fail
		age_gateway_fail_pdp(container);
		// set cookie: fail
		age_gateway_fail_cookie(form);
	}
}

// **************************************************************** //
// ANNOUNCEMENT BAR
// **************************************************************** //

function announcementbar_close() {
	// remove parent
	jQuery('#announcementbar').remove();
	// remove all children
	jQuery('.announcementbar-container').remove();
	jQuery('body').addClass('announcement-close');
}

function announcementbar_cycle() {
	var j = 0;
   	var delay = 3000; //millisecond delay between cycles
   	if ($(".announcementbar-msg div").length > 1) {
	   	function cycleThru(){
	   		var jmax = $(".announcementbar-msg div").length -1;
	   		$(".announcementbar-msg div:eq(" + j + ")")
	   		.animate({"opacity" : "1", "z-index" : "2"} ,400)
	   		.animate({"opacity" : "1", "z-index" : "2"}, delay)
	   		.animate({"opacity" : "0", "z-index" : "1"}, 400, function(){
	           (j == jmax) ? j=0 : j++;
	           cycleThru();
	   		});
	   	};
	   	cycleThru()
	}
	else {
		$(".announcementbar-msg div").css('opacity', '1');
	}
}

function body_scroll_stop() {
	
	if(megamenu_screen() == 'mobile') {
		jQuery('body').addClass('noscroll');
	}
	else {
		jQuery('body').removeClass('noscroll');
	}
}

function body_scroll_start() {
	jQuery('body').removeClass('noscroll');
}

function megamenu_screen() {
	if(jQuery(window).outerWidth() >= 1200) {
		return 'desktoplg';
	}
	else if(jQuery(window).outerWidth() < 1200 && jQuery(window).outerWidth() >= 1000) {
		return 'desktopmd';
	}
	else {
		return 'mobile';
	}
}

function screendm_megamenu() {
	if(jQuery(window).outerWidth() >= 1000) {
		return 'desktop';
	}
	else {
		return 'mobile';
	}
}

// expects input to be JS DOM object (not jQuery object or text string)
function strip_zeroes(t) {
	// console.log( 'strip_zeroes()' );
	// console.log( 't', t );
	if(t.innerHTML.includes('.00')) {
		t.innerHTML = t.innerHTML.replace('.00', '');
	}
}

function is_pdp() {
	if(jQuery('[data-pdp]').length === 1) {
		return true;
	}
	else {
		return false;
	}
}

// **************************************************************** //
// PDP - STICKY CTA BAR
// **************************************************************** //

function pdp_stickycta_scroll() {
	var stickyCTA = jQuery('#pdp-stickycta'),
	stickyMainNav = $('.megamenu'),
	pageWindow = $(window),
	holidayShippingDot = $('#holiday-shipping'),
	position = $(window).scrollTop();
	

		if(screendm_megamenu() == 'desktop') {

			$('#sticky-cta-waypoint').waypoint(function(direction) {
			    if (direction === 'down') {
			      	stickyCTA.addClass('visible');
			      	stickyMainNav.addClass('hide');
			    }
			    else {
			      	stickyCTA.removeClass('visible');
			      	stickyMainNav.removeClass('hide');
			    }
			  }, {
			    offset: '-40px'
			})
	    } else {
		    $('#sticky-cta-waypoint').waypoint(function(direction) {
			    if (direction === 'down') {
			      	stickyCTA.addClass('visible');
			      	holidayShippingDot.addClass('scootUp');
			    }
			    else {
			      	stickyCTA.removeClass('visible');
			      	holidayShippingDot.removeClass('scootUp');
			    }
			  }, {
			    offset: '20px'
			})

			var inview = new Waypoint.Inview({
				  element: $('#section-footer')[0],
				  enter: function(direction) {
				    stickyCTA.removeClass('activated');
			    	stickyCTA.removeClass('visible');
			      	holidayShippingDot.removeClass('scootUp');
				  },
				  entered: function(direction) {
				    //notify('Entered triggered with direction ' + direction)
				  },
				  exit: function(direction) {
				    //notify('Exit triggered with direction ' + direction)
				  },
				  exited: function(direction) {
				    stickyCTA.addClass('visible');
			      	stickyCTA.addClass('activated');
			      	holidayShippingDot.addClass('scootUp');
				  }
				})

	    }

		var scroll = $(window).scrollTop();
	    if(scroll > position) {
			stickyCTA.removeClass('activated');
			stickyMainNav.removeClass('activated');
	    } else {
	        stickyCTA.addClass('activated');
	        stickyMainNav.addClass('activated');
	    }
	    position = scroll;
}

// DESKTOP PDP MEDIA GALLERY

function pdp_media(parent, pos) {
	// console.log( `pdp_media()` );
	// console.log( `parent`, parent );
	// console.log( `pos`, pos );
	// thumbs
	jQuery(parent).find('.pdp-media-d-thumbnails').find('.pdp-media-thumbnail-item').removeClass('active');
	jQuery(parent).find('.pdp-media-d-thumbnails').find('[data-pos="' + pos + '"]').addClass('active');
	// fulls
	jQuery(parent).find('.pdp-media-d-fulls').find('.pdp-media-item').removeClass('active');
	jQuery(parent).find('.pdp-media-d-fulls').find('[data-pos="' + pos + '"]').addClass('active');
}

function pdp_media_next(parent) {
	var availability_map = [];
	jQuery(parent).find('.pdp-media-d-thumbnails > .pdp-media-thumbnail-item').each(function() {
		availability_map.push(jQuery(this).data('pos'));
	});
	var current_pos = jQuery(parent).find('.pdp-media-d-thumbnails > .pdp-media-thumbnail-item.active').data('pos');
	var next_pos = availability_map[(jQuery.inArray(current_pos, availability_map) + 1) % availability_map.length];
	// console.log( `availability_map`, availability_map );
	// console.log( `current_pos`, current_pos );
	// console.log( `next_pos`, next_pos );
	pdp_media(parent, next_pos);
}

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //

// MOBILE PDP MEDIA GALLERY

function pdp_owl_height_set(stage) {
	// console.log( `pdp_owl_height_set()` );
	// console.log( `stage`, stage );
	stage.children().each(function() {
		if(jQuery(this).find('iframe').length > 0) {
			jQuery(this).find('iframe').css('height', stage.outerHeight() + 'px');
		}
		else {
			var margintop = ((stage.outerHeight() / 2) - (jQuery(this).outerHeight() / 2));
			jQuery(this).find('img').css('height', stage.outerHeight() + 'px');;
			jQuery(this).find('img').css('height', stage.outerHeight() + 'px');;
		}
	});
}

function pdp_owl_height() {
	// console.log( `pdp_owl_height()` );
	// console.log( `this`, this );
	pdp_owl_height_set(this.$stage);
}

function pdp_owl_init() {
	// console.log( `pdp_owl_init()` );
	// console.log( `this`, this );
	// set height
	pdp_owl_height_set(this.$stage);
	// redraw media
	setTimeout(function() {
		// console.log( `++++++++++ this.$element`, this.$element );
		// this.$element.trigger('next.owl.carousel');
		pdp_select_variant(jQuery(this.$element).closest('.pdp-container').find('form.pdp-form').get(0));
	}.bind(this), 1);
}

function pdp_owl_refreshed() {
	// console.log( `pdp_owl_refreshed()` );
	// console.log( `this`, this );
	// set height
	pdp_owl_height_set(this.$stage);
	// go to var alt media
	// console.log( `>>>>> jQuery(this.$element).data('m_gallery_goto')`, jQuery(this.$element).data('m_gallery_goto') );
	var m_gallery_goto = parseInt(jQuery(this.$element).data('m_gallery_goto'));
	// console.log( `>>>>> m_gallery_goto`, m_gallery_goto );
	if(!isNaN(m_gallery_goto)) {
		setTimeout(function() {
			this.$element.trigger('to.owl.carousel', [m_gallery_goto, 0]);
		}.bind(this), 1);
	}
}

// PDP - AJAX ADD TO CART

function pdp_ajax_atc(obj) {
	// if no gateway restrictions are present...
	if(
		!jQuery(obj).closest('.product-form').hasClass('zipcodegateway')
		&&
		!jQuery(obj).closest('.product-form').hasClass('agegateway')
	) {
		// Klaviyo "Add To Cart" metric
		klaviyo_atc_metric(obj);
		// ajax add to cart
		pdp_atc(obj);
		ajaxCart.load();
	}
	// if at least one gateway restriction is present...
	else {
		var gateway_restrictions = [];
		if(jQuery(obj).closest('.product-form').hasClass('zipcodegateway')) {
			gateway_restrictions.push('zipcodegateway');
		}
		if(jQuery(obj).closest('.product-form').hasClass('agegateway')) {
			gateway_restrictions.push('agegateway');
		}
		// do not add to cart
		console.warn('Add to cart failed: gateway restrictions in place.', gateway_restrictions);
	}
	return false;
}

function klaviyo_atc_metric(obj) {
	// Klaviyo "Add To Cart" metric
	/*
	var $KlaviyoProductInfo = jQuery(obj).find('[data-klaviyo-product-info]');
	var klaviyo_product_info = {
		"Name": $KlaviyoProductInfo.data('klaviyo-product-info-name'),
		"ProductID": $KlaviyoProductInfo.data('klaviyo-product-info-product-id'),
		"Categories": $KlaviyoProductInfo.data('klaviyo-product-info-collections'),
		"ImageURL": $KlaviyoProductInfo.data('klaviyo-product-info-image'),
		"URL": $KlaviyoProductInfo.data('klaviyo-product-info-url'),
		"Brand": $KlaviyoProductInfo.data('klaviyo-product-info-brand'),
		"Price": $KlaviyoProductInfo.data('klaviyo-product-info-price'),
		"CompareAtPrice": $KlaviyoProductInfo.data('klaviyo-product-info-compare-at-price')
	};
	var _learnq = _learnq || [];
	_learnq.push(['track', 'Added to Cart', klaviyo_product_info]);
	console.log( `Klaviyo metric fired: "Added to Cart"`, klaviyo_product_info );
	*/
}

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //

// *** COOKIE FUNCTIONS *** //

// * parse all cookies * //
// * param `c` must be `document.cookie` * //
function cookiesParse(c) {
	if(typeof c == 'undefined') {
		c = document.cookie;
	}
	var o = {};
	var x = c.split('; ');
	for(var iA = 0; iA < x.length; iA++) {
		var y = x[iA].trim().split(/=(.+)/);
		o[y[0]] = y[1];
	}
	return o;
}

// * set a cookie (create or overwrite) * //
// * assign key, value, num days before expiring * //
function cookieSet(key, value, num_days, path, domain) {
	if(typeof path == 'undefined') {
		path = '/';
	}
	if(typeof domain == 'undefined') {
		domain = location.hostname.replace('www.', '');
	}
	if(num_days) {
		var date = new Date();
		date.setTime(date.getTime() + (num_days * 24 * 60 * 60 * 1000));
		var expires = '; expires=' + date.toGMTString();
	}
	else {
		var expires = '';
	}
	document.cookie = key + '=' + value + expires + '; path=' + path + '; domain=' + domain;
}

// * get an existing cookie value * //
// * retreive cookie value by key * //
function cookieGet(key) {
	var keyEQ = key + '=';
	var ca = document.cookie.split(';');
	for(var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while(c.charAt(0) == ' ') {
			c = c.substring(1, c.length);
			if(c.indexOf(keyEQ) == 0) {
				return c.substring(keyEQ.length, c.length);
			}
		}
	}
	return null;
}

// * delete a cookie * //
// * delete a cookie by key * //
function cookieDelete(key) {
	createCookie(key, '', -1);
}

// * cookie JSON → stringify → Base64 encode * //
function cookieEncode(dec) {
	return window.btoa(JSON.stringify(dec));
	//return JSON.stringify(dec);
}

// * Base64 cookie decode → JSON * //
function cookieDecode(enc) {
	return JSON.parse(window.atob(enc));
	//return JSON.parse(enc);
}

// **************************************************************** //

// *** PARSE UTM QUERY PARAMS *** //

function getQueryParams(ls) {
	if(typeof ls == 'undefined') {
		var ls = location.search;
	}
	var qp = ls.substring(1).split('&');
	var o = {};
	var x = 0;
	if(ls != '' & qp.length >= 1) {
		for(var i = 0; i < qp.length; i++) {
			qpi = qp[i].split('=');
			o[qpi[0]] = qpi[1];
			x++;
		}
	}
	if(x > 0) {
		return o;
	}
	return false;
}

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //

function pdp_select_variant_set(form, variant) {
	// console.log( `~~ pdp_select_variant_set(form, variant)`, form, variant );

	// get all variants

	var all_variants = false;

	if(jQuery(form).find('[data-variant-map]').length > 0) {
		all_variants = JSON.parse(jQuery(form).find('[data-variant-map]').html());
		// console.log( `~~ all_variants`, all_variants );
	}
	
	// set variant as active
	jQuery(form).data('selected-variant', variant);
	
	// if available
	if(variant.available) {
		// disable oos form
		if(jQuery(form).find('.product-form--oos').hasClass('active')) {
			jQuery(form).find('.product-form--oos').removeClass('active');
		}
		// enable qty & atc btn
		if(!jQuery(form).find('.product-form--qty').hasClass('active')) {
			jQuery(form).find('.product-form--qty').addClass('active');
		}
		if(!jQuery(form).find('.product-form--atc').hasClass('active')) {
			jQuery(form).find('.product-form--atc').addClass('active');
		}
	}
	// if unavailable
	else {
		// disable qty & atc btn
		if(jQuery(form).find('.product-form--qty').hasClass('active')) {
			jQuery(form).find('.product-form--qty').removeClass('active');
		}
		if(jQuery(form).find('.product-form--atc').hasClass('active')) {
			jQuery(form).find('.product-form--atc').removeClass('active');
		}
		// enable oos form
		if(!jQuery(form).find('.product-form--oos').hasClass('active')) {
			jQuery(form).find('.product-form--oos').addClass('active');
		}
	}
	
	// set OOS notify form variant SKU : [name="$fields"]
	var _fields = jQuery(form).closest('.product-form').find('form.pdp-oos-notify-form').find('[name="$fields"]').val().split(',');
	_fields.forEach(function(field) {
		if(field.startsWith('pdp_bis_')) {
			_fields[_fields.indexOf(field)] = 'pdp_bis_' + variant.sku;
		}
	});
	var _fields = _fields.join(',');
	jQuery(form).closest('.product-form').find('form.pdp-oos-notify-form').find('[name="$fields"]').val(_fields);
	
	// set OOS notify form variant SKU : [name^="pdp_bis_"]
	jQuery(form).closest('.product-form').find('form.pdp-oos-notify-form').find('[name^="pdp_bis_"]').attr('name', 'pdp_bis_' + variant.sku);
	
	// render Afterpay...
	pdp_afterpay_render(form);
	
	// set `id` : original product variant ID
	jQuery(form).find('[name="id"]').val(variant.variant_id);
	// if product has subscription
	if(jQuery(form).find('[name="offers-subscription"]').val() == "true") {
		// if customer has selected subscription option
		if(jQuery(form).find('[data-purchase-type]:checked').val() == "autodeliver") {
			// (if JSON is valid)
			if(variant.hasOwnProperty('subx_variant_id')) {
				if(variant.subx_variant_id != null && variant.subx_variant_id != "") {
					// set `id` : subx product variant ID
					jQuery(form).find('[name="id"]').val(variant.subx_variant_id);
				}
			}
		}
	}
	
	// set price
	// console.log( 'NOW SET PRICE', variant );
	
	// price actual
	jQuery(form).find('[data-pdp-form-price-actual]').text(variant.price_money);
	jQuery(form).find('[data-pdp-form-subx-onetime-price-actual]').text(variant.price_money);
	
	// compare at price
	jQuery(form).find('[data-pdp-form-price-compareat]').text(variant.compare_at_money);
	jQuery(form).find('[data-pdp-form-subx-onetime-price-compareat]').text(variant.compare_at_money);
	
	// subx price
	jQuery(form).find('[data-pdp-form-subx-recurring-price-actual]').text(variant.subx_price_money);
	jQuery(form).find('[data-pdp-form-subx-recurring-price-compareat]').text(variant.subx_compare_at_money);
	
	// sticky CTA buttons price
	if(jQuery('#pdp-stickycta').length > 0) {

		jQuery('#pdp-stickycta').find('[data-pdp-form-price-actual]').text(variant.price_money);
		jQuery('#pdp-stickycta').find('[data-pdp-form-subx-onetime-price-actual]').text(variant.price_money);

		jQuery('#pdp-stickycta').find('[data-pdp-form-price-compareat]').text(variant.compare_at_money);
		jQuery('#pdp-stickycta').find('[data-pdp-form-subx-onetime-price-compareat]').text(variant.compare_at_money);

		jQuery('#pdp-stickycta').find('[data-pdp-form-subx-recurring-price-actual]').text(variant.subx_price_money);
		jQuery('#pdp-stickycta').find('[data-pdp-form-subx-recurring-price-compareat]').text(variant.subx_compare_at_money);
	}

	// if onetime
	if(jQuery(form).find('[data-purchase-type]:checked').val() == 'onetime') {
		jQuery('[data-atc-mimic]').find('.active-pay-price').text(variant.price_money);
		if(variant.price < variant.compare_at) {
			jQuery('[data-atc-mimic]').find('.active-crossout-price').text(variant.compare_at_money);
		}
		else {
			jQuery('[data-atc-mimic]').find('.active-crossout-price').text('');
		}
		// set Klaviyo metric prices
		jQuery(form).find('[data-klaviyo-product-info]').data('klaviyo-product-info-price', variant.price_money);
		jQuery(form).find('[data-klaviyo-product-info]').data('klaviyo-product-info-compare-at-price', variant.compare_at_money);
	}
	// if recurring
	else {
		jQuery('[data-atc-mimic]').find('.active-pay-price').text(variant.subx_price_money);
		if(variant.subx_price < variant.subx_compare_at) {
			jQuery('[data-atc-mimic]').find('.active-crossout-price').text(variant.subx_compare_at_money);
		}
		else {
			jQuery('[data-atc-mimic]').find('.active-crossout-price').text('');
		}
		// set Klaviyo metric prices
		jQuery(form).find('[data-klaviyo-product-info]').data('klaviyo-product-info-price', variant.subx_price_money);
		jQuery(form).find('[data-klaviyo-product-info]').data('klaviyo-product-info-compare-at-price', variant.subx_compare_at_money);
	}
	
	// price afterpay
	jQuery(form).find('[data-pdp-form-price-afterpay]').text(variant.price_afterpay_money);
	
	jQuery(form).find('.afterpay-container').removeClass('active');
	// if variant price >= $35
	if(variant.price >= 3500) {
		// show container: afterpay eligible
		jQuery(form).find('.afterpay-eligible').addClass('active');
	}
	else {
		// show container: afterpay ineligible
		jQuery(form).find('.afterpay-ineligible').addClass('active');
	}
	
	// membership faux option
	if(jQuery(form).find('[data-membership-faux-variant-map]').length > 0) {
		var membership_faux_data = jQuery(form).find('[data-membership-faux-variant-map]').data('membership-faux-variant-map');
		for(mfd_variant_id in membership_faux_data) {
			if(mfd_variant_id == variant.variant_id) {
				jQuery('.membership-faux-memberprice').html(membership_faux_data[mfd_variant_id].memberprice);
				jQuery('.membership-faux-crossoutprice').html(membership_faux_data[mfd_variant_id].crossoutprice);
			}
		}
	}

	// ************************************************** //
	
	// render media gallery (desktop)
	// ...deselect active media
	jQuery(form).closest('.pdp-container').find('.pdp-media-thumbnail-item').removeClass('active off');
	jQuery(form).closest('.pdp-container').find('.pdp-media-d-fulls > .pdp-media-item').removeClass('active off');
	// ...hide all with alt text
	jQuery(form).closest('.pdp-container').find('.pdp-media-thumbnail-item, .pdp-media-d-fulls > .pdp-media-item').each(function() {
		if(jQuery(this).data('alt') != '') {
			var alt_text = jQuery(this).data('alt');
			var variant_match = false;
			variant.options.forEach(function(option, i) {
				if(alt_text == option) {
					variant_match = option;
				}
			});
			if(variant_match) {
				jQuery(this).addClass('active');
			}
			else {
				jQuery(this).addClass('off');
			}
		}
	});
	if(jQuery(form).closest('.pdp-container').find('.pdp-media-thumbnail-item.active').length == 0) {
		jQuery(form).closest('.pdp-container').find('.pdp-media-thumbnail-item:not(.off)').first().addClass('active');
	}
	if(jQuery(form).closest('.pdp-container').find('.pdp-media-d-fulls > .pdp-media-item.active').length == 0) {
		jQuery(form).closest('.pdp-container').find('.pdp-media-d-fulls > .pdp-media-item:not(.off)').first().addClass('active');
	}
	
	// ************************************************** //
	
	// render media gallery (mobile)
	// jQuery(form).closest('.pdp-container').find('.pdp-media-m-carousel').trigger('to.owl.carousel', [3]);
	var m_gallery_refresh = ``;
	var m_gallery_newslides = [];
	var m_gallery_goto = false;
	jQuery(form).closest('.pdp-container').find('.pdp-media-preload').children().each(function(i) {
		var pdp_labels_output = '';
		if(i == 0) {
			if(jQuery(form).closest('.pdp-container').data('pdp-labels')) {
				var pdp_labels = jQuery(form).closest('.pdp-container').data('pdp-labels').split('|');
				pdp_labels_output = `<div class="pdp-media-badges">`;
				pdp_labels.forEach(pdp_label => {
					pdp_labels_output += `<div class="pdp-media-badge">` + pdp_label + `</div>`;
				});
				pdp_labels_output += `</div>`;
				// console.log( `~~ pdp_labels_output`, pdp_labels_output );
			}
		}
		if(jQuery(this).data('alt') == '') {
			m_gallery_refresh += `<div class="pdp-media-item" data-type="` + jQuery(this).data('type') + `" data-alt="` + jQuery(this).data('alt') + `" data-pos="` + jQuery(this).data('pos') + `">` + pdp_labels_output + jQuery(this).html() + `</div>`;
			m_gallery_newslides.push(jQuery(this).data('pos'));
		}
		else {
			var alt_text = jQuery(this).data('alt').toString();
			var variant_match = false;
			all_variants.forEach(function(this_variant, i) {
				x = i + 1;
				if(this_variant.options.includes(alt_text)) {
					variant_match = alt_text;
					pos_match = x;
				}
			});
			if(variant_match) {
				m_gallery_refresh += `<div class="pdp-media-item" data-type="` + jQuery(this).data('type') + `" data-alt="` + jQuery(this).data('alt') + `" data-pos="` + jQuery(this).data('pos') + `">` + pdp_labels_output + jQuery(this).html() + `</div>`;
				m_gallery_newslides.push(jQuery(this).data('pos'));
			}
			if(variant.options.includes(alt_text)) {
				m_gallery_goto = jQuery(this).data('pos');
			}
		}
	});
	if(m_gallery_goto) {
		m_gallery_goto = m_gallery_newslides.indexOf(m_gallery_goto);
		jQuery(form).closest('.pdp-container').find('.pdp-media-m-carousel').data('m_gallery_goto', m_gallery_goto);
	}
	else {
		jQuery(form).closest('.pdp-container').find('.pdp-media-m-carousel').data('m_gallery_goto', false);
	}
	jQuery(form).closest('.pdp-container').find('.pdp-media-m-carousel').trigger('replace.owl.carousel', [m_gallery_refresh]);
	jQuery(form).closest('.pdp-container').find('.pdp-media-m-carousel').trigger('refresh.owl.carousel');
	jQuery(form).closest('.pdp-container').find('.pdp-media-m-carousel').trigger('to.owl.carousel', [m_gallery_goto, 0]);
	
	// ************************************************** //
	
	// render variant attr contents
	if(jQuery(form).closest('.pdp-form-container').find('[data-variant-attr-contents]').length > 0) {
		// turn all off
		jQuery(form).closest('.pdp-form-container').find('[data-variant-attr-contents]').each(function() {
			if(!jQuery(this).hasClass('off')) {
				jQuery(this).addClass('off');
			}
		});
		// turn on selected variant attr contents
		jQuery(form).closest('.pdp-form-container').find('[data-variant-attr-contents][data-variant-id="' + variant.variant_id + '"]').removeClass('off');
	}
	
	// ************************************************** //
	
	// (VOID) serialize
	var serialize = '?' + decodeURI(jQuery(form).serialize()).replaceAll("&", "\n&");
	// console.log( serialize );
	
}

function pdp_select_variant(form) {
	// console.log( `pdp_select_variant()` );
	// console.log( 'form', form );
	var pdp_variant_map = JSON.parse(jQuery(form).find('[data-variant-map]').html());
	// console.log( 'pdp_variant_map', pdp_variant_map );
	var options = jQuery(form).data('options').split(',');
	// console.log( 'options', options );
	// if multiple variants
	if(pdp_variant_map.length > 1) {
		var option_values = {};
		// console.log( 'options', options );
		for(var i = 0; i < options.length; i++) {
			var x = i + 1;
			// console.log( 'options[' + i + ']', options[i] );
			option_values['option' + x] = jQuery(form).find('[name="' + options[i] + '"]:checked').val();
		}
		// console.log( 'option_values', option_values );
		pdp_variant_map.forEach(function(variant, i) {
			// console.log( 'variant', variant );
			var matches = 0;
			var num_options = variant.options.length;
			for(option_value in option_values) {
				// console.log( '[' + i + '] option_value:key', option_value );
				// console.log( '[' + i + '] option_value:value', option_values[option_value] );
				// console.log( 'match?', variant[option_value], option_values[option_value] );
				if(variant[option_value] == option_values[option_value]) {
					matches++;
					// console.log( 'MATCH!', matches );
				}
				else {
					// console.log( '(fail)' );
				}
			}
			// console.log( 'matches', matches );
			// console.log( 'num_options', num_options );
			if(matches == num_options) {
				// VARIANT FOUND
				// console.log( 'MATCH FOUND', variant );
				// console.log( '[A] pdp_select_variant() > CALLING: pdp_select_variant_set()' );
				// console.log( '[A] passing variant:', variant );
				pdp_select_variant_set(form, variant);
				// set subscriptionOption
				pdp_set_subscriptionoption_prop(form, variant);
			}
		});
	}
	// if only one variant
	else {
		// console.log( '[B] pdp_select_variant() > CALLING: pdp_select_variant_set()' );
		// console.log( '[B] passing variant:', pdp_variant_map[0] );
		pdp_select_variant_set(form, pdp_variant_map[0]);
	}
}

// **************************************************************** //

function pdp_subx_option(form) {
	// console.log( `~~ pdp_subx_option(form)`, form );
	// console.log( `~~ jQuery(form).find('[data-purchase-type]:checked').val()`, jQuery(form).find('[data-purchase-type]:checked').val() );
	// IF: ONE TIME
	if(jQuery(form).find('[data-purchase-type]:checked').val() == 'onetime') {
		// remove [name="selling_plan"] from recurring <select>
		jQuery(form).find('[data-selling-plan]').removeAttr('name');
		// set 'add to cart' button text: default
		jQuery(form).find('[data-pdp-atc]').text(jQuery(form).find('[data-pdp-atc]').data('label-default'));
		// mark active 'add to cart' button text: default
		jQuery(form).find('[data-pdp-atc]').data('label-active', 'default');
		// set mimic 'add to cart' button text: default
		jQuery('[data-atc-mimic] > .active-cta').text(jQuery(form).find('[data-pdp-atc]').data('label-default'));
		// set sticky cta bar buttons (mobile) > onetime
		if(jQuery(form).find('#ProductFormMainPlacement').length > 0) {
			jQuery('#pdp-stickycta').find('.pdp-stickycta-buttons').removeClass('recurring');
		}
	}
	// IF: RECURRING
	else {
		// add [name="selling_plan"] back to recurring <select>
		jQuery(form).find('[data-selling-plan]').attr('name', 'selling_plan');
		// set 'add to cart' button text: subx
		jQuery(form).find('[data-pdp-atc]').text(jQuery(form).find('[data-pdp-atc]').data('label-subx'));
		// mark active 'add to cart' button text: subx
		jQuery(form).find('[data-pdp-atc]').data('label-active', 'subx');
		// set mimic 'add to cart' button text: default
		jQuery('[data-atc-mimic] > .active-cta').text(jQuery(form).find('[data-pdp-atc]').data('label-subx'));
		// set sticky cta bar buttons (mobile) > onetime
		if(jQuery(form).find('#ProductFormMainPlacement').length > 0) {
			jQuery('#pdp-stickycta').find('.pdp-stickycta-buttons').addClass('recurring');
		}
	}
	console.log(
		'pdp_subx_option()',
		jQuery(form).find('[data-purchase-type]:checked').val(),
		(jQuery(form).find('[name="selling_plan"]').length > 0) ? jQuery(form).find('[name="selling_plan"]').val() : ''
	);
	// set variant ID
	pdp_select_variant(form);
}

function pdp_atc_mimic(product_id, subx, atc_source_placement) {
	console.log( `pdp_atc_mimic()`, product_id );
	console.log( `jQuery('#product_form_' + product_id)`, jQuery('#product_form_' + product_id) );
	if(typeof subx == 'undefined') {
		subx = false;
	}
	var source_placement = false;
	if(atc_source_placement != '') {
		source_placement = atc_source_placement;
	}
	// console.log( `~~ source_placement`, source_placement );
	// console.log( `~~ jQuery('#product_form_' + product_id).find('[name="properties[_atc_source_placement]"]')`, jQuery('#product_form_' + product_id).find('[name="properties[_atc_source_placement]"]') );
	// if product is in stock
	if(jQuery('#product_form_' + product_id).find('.product-form--atc').hasClass('active')) {
		// if any gateway restrictions are present and not passed
		if(
			jQuery('#product_form_' + product_id).hasClass('zipcodegateway')
			||
			jQuery('#product_form_' + product_id).hasClass('agegateway')
		) {
			// scroll to pdp form
			jQuery(window).scrollTo(jQuery('#product_form_' + product_id), 250, 'easeOutQuad');
			// if zipcode gateway form present
			if(jQuery('#product_form_' + product_id).hasClass('zipcodegateway')) {
				// focus in zipcode gateway form field
				jQuery('#product_form_' + product_id).find('[name="zipcode"]').select();
			}
		}
		// if all gateway restrictions are passed (or none are present)
		else {
			// if has subscription
			if(subx) {
				if(subx == 'onetime') {
					// if subx onetime: check onetime radio button
					jQuery('#product_form_' + product_id).find('[data-purchase-type-onetime]').prop('checked', true).trigger('onchange');
				}
				else {
					// if subx recurring: check recurring radio button
					jQuery('#product_form_' + product_id).find('[data-purchase-type-recurring]').prop('checked', true).trigger('onchange');
				}
			}
			// if has source placement value
			if(source_placement) {
				if(!jQuery('#product_form_' + product_id).find('[name="properties[_atc_source_placement]"]').hasClass('revised')) {
					// console.log( `~~~ jQuery('.product-id-' + product_id + '[name="properties[_atc_source_placement]"]')`, jQuery('.product-id-' + product_id + '[name="properties[_atc_source_placement]"]') );
					// set add to cart source placement attribution line item property value
					jQuery('.product-id-' + product_id + '[name="properties[_atc_source_placement]"]').val(source_placement);
				}
			}
			// trigger form submit
			console.log( `pdp_ajax_atc() > jQuery('#product_form_' + product_id)`, jQuery('#product_form_' + product_id) );
			pdp_ajax_atc(jQuery('#product_form_' + product_id));
		}
	}
	// if product is out of stock
	else {
		// scroll to pdp form
		jQuery(window).scrollTo(jQuery('#product_form_' + product_id), 250, 'easeOutQuad');
	}
}

// **************************************************************** //

function pdp_set_subscriptionoption_prop(form, variant) {
	console.log( `pdp_set_subscriptionoption_prop(form, variant)`, form, variant );
	jQuery(form).find('[data-subscriptionoption]').attr('name', '');
	jQuery(form).find('[data-subscriptionoptionvariantid="' + variant.variant_id + '"]').attr('name', 'properties[_subscriptionOption]');
}

// **************************************************************** //

function pdp_afterpay_render(form) {
	// console.log( `parseInt(jQuery(form).data('debug-id'))`, parseInt(jQuery(form).data('debug-id')) );
	// var debug_id = parseInt(jQuery(form).data('debug-id'));
	// if(!debug_id) {
	// 	debug_id = 0;
	// }
	// debug_id++;
	// console.log( `debug_id`, debug_id );
	// jQuery(form).data('debug-id', debug_id);
	// jQuery(form).find('.product-form--afterpay').after(debug_id + `:<br /><textarea data-debug-id="` + debug_id + `">`+ jQuery(form).find('.product-form--afterpay').html() + `</textarea><br />`);
	// console.log( `jQuery(form).find('[data-offers-afterpay]').length`, jQuery(form).find('[data-offers-afterpay]').length );
	
	if(jQuery(form).find('[data-offers-afterpay]').length > 0) {
		var variant = jQuery(form).data('selected-variant');
		// if selected variant is available...
		if(variant.available) {
			// if has subscription...
			if(jQuery(form).find('[data-pdp-offers-subscription]').val() == 'true') {
				// if current subx option is onetime...
				if(jQuery(form).find('[data-purchase-type]:checked').val() == 'onetime') {
					// show Afterpay message text...
					// alert('[A] SHOW');
					pdp_afterpay_render_show(form);
				}
				// if current subx option is recurring...
				else {
					// make Afterpay message invisible (maintain vertical height)
					// alert('[B] INVISIBLE');
					pdp_afterpay_render_invisible(form);
				}
			}
			// if does not have subscription...
			else {
				// show Afterpay message text...
				// alert('[C] SHOW');
				pdp_afterpay_render_show(form);
			}
		}
		// if selected variant is unavailable...
		else {
			// hide Afterpay message altogether (shrink vertical height)
			// alert('[D] HIDE');
			pdp_afterpay_render_hide(form);
		}
	}
}

// ********** //

function pdp_afterpay_render_show(form) {
	// console.log( `pdp_afterpay_render_show()` );
	// show Afterpay message text...
	// ***
	// show afterpay: unset hide
	jQuery(form).find('[data-pdp-afterpay-duplicate]').css('visibility', '');
	// show afterpay: enable
	jQuery(form).find('[data-pdp-afterpay-duplicate]').css('display', '');
}

function pdp_afterpay_render_invisible(form) {
	// console.log( `pdp_afterpay_render_invisible()` );
	// make Afterpay message invisible (maintain vertical height)
	// ***
	// enable, for vertical width, but...
	jQuery(form).find('[data-pdp-afterpay-duplicate]').css('display', '');
	// hide afterpay
	jQuery(form).find('[data-pdp-afterpay-duplicate]').css('visibility', 'hidden');
}

function pdp_afterpay_render_hide(form) {
	// console.log( `pdp_afterpay_render_hide()` );
	// hide Afterpay message altogether (shrink vertical height)
	// ***
	// disable
	jQuery(form).find('[data-pdp-afterpay-duplicate]').css('display', 'none');
	// unset hide
	jQuery(form).find('[data-pdp-afterpay-duplicate]').css('visibility', '');
}

// ********** //

function pdp_afterpay_render_show_TEMP(form) {
	// console.log( `pdp_afterpay_render_show_TEMP()` );
	// show Afterpay message text...
	// ***
	// duplicate placeholder: on
	jQuery(form).find('[data-pdp-afterpay-duplicate]').css('display', '');
	// duplicate placeholder: unset `visibility`
	jQuery(form).find('[data-pdp-afterpay-duplicate]').css('visibility', '');
	// ***
}

function pdp_afterpay_render_invisible_TEMP(form) {
	// console.log( `pdp_afterpay_render_invisible_TEMP()` );
	// make Afterpay message invisible (maintain vertical height)
	// ***
	// duplicate placeholder: on (but...)
	jQuery(form).find('[data-pdp-afterpay-duplicate]').css('display', '');
	// duplicate placeholder: set invisible
	jQuery(form).find('[data-pdp-afterpay-duplicate]').css('visibility', 'hidden');
	// ***
}

function pdp_afterpay_render_hide_TEMP(form) {
	// console.log( `pdp_afterpay_render_hide_TEMP()` );
	// hide Afterpay message altogether (shrink vertical height)
	// ***
	// duplicate placeholder: off
	jQuery(form).find('[data-pdp-afterpay-duplicate]').css('display', 'none');
	// duplicate placeholder: unset `visibility`
	jQuery(form).find('[data-pdp-afterpay-duplicate]').css('visibility', '');
	// ***
}

// ********** //

function pdp_afterpay_popup_open() {
	jQuery('afterpay-modal').attr('visible', 'visible');
}

function pdp_afterpay_popup_close() {
	jQuery('afterpay-modal').removeAttr('visible');
}

function pdp_afterpay_popup_toggle() {
	// if closed
	if(!jQuery('afterpay-modal').attr('visible')) {
		pdp_afterpay_popup_open();
	}
	// if open
	else {
		pdp_afterpay_popup_close();
	}
}

// **************************************************************** //

function pdp_qty_validate(input, field) {
	var qty = parseInt(input);
	if(isNaN(qty)) {
		qty = 1;
	}
	var min = parseInt(jQuery(field).attr('min'));
	var max = parseInt(jQuery(field).attr('max'));
	if(qty < min) {
		qty = min;
	}
	else if(qty > max) {
		qty = max;
	}
	return qty;
}

function pdp_qty_validate_field(field) {
	var qty = pdp_qty_validate(field.value, field);
	jQuery(field).val(qty);
}

function pdp_qty_dec(form) {
	// console.log( 'pdp_qty_dec()', form );
	var qty_current = pdp_qty_validate(jQuery(form).find('[data-pdp-qty]').val(), jQuery(form).find('[data-pdp-qty]'));
	var qty_new = pdp_qty_validate((qty_current - 1), jQuery(form).find('[data-pdp-qty]'));
	jQuery(form).find('[data-pdp-qty]').val(qty_new);
}

function pdp_qty_inc(form) {
	// console.log( 'pdp_qty_inc()', form );
	// console.log( `jQuery(form).find('[data-pdp-qty]').val()`, jQuery(form).find('[data-pdp-qty]').val() );
	var qty_current = pdp_qty_validate(jQuery(form).find('[data-pdp-qty]').val(), jQuery(form).find('[data-pdp-qty]'));
	var qty_new = pdp_qty_validate((qty_current + 1), jQuery(form).find('[data-pdp-qty]'));
	// console.log( 'qty_current', qty_current );
	// console.log( 'qty_new', qty_new );
	jQuery(form).find('[data-pdp-qty]').val(qty_new);
}

function bsr_response_handler() {
	const res = JSON.parse(this.responseText);
	for(const [key, value] of Object.entries(res)) {
		// console.log( `~~ replacing:`, key );
		const innerHTML = new DOMParser()
			.parseFromString(value, 'text/html')
			.getElementById('shopify-section-' + key).innerHTML;
		document.getElementById('shopify-section-' + key).innerHTML = innerHTML;
		try {
			runScripts(document.getElementById('shopify-section-' + key));
		}
		catch(e) {
			console.warn('TS CTA - Unable to call `runScripts()`', e);
		}
	}
}

function bsr(bsr_sections) {
	const request = new XMLHttpRequest();
	request.addEventListener('load', bsr_response_handler);
	request.open('GET', window.location.pathname + '?sections=' + bsr_sections, true);
	request.send();
}

// **************************************************************** //

// NEVER CALL THIS FUNCTION MANUALLY. ONLY SUBMIT SHOPIFY PRODUCT ADD TO CART FORM WITH THIS FUNCTION AS AN "ONSUBMIT" HANDLER.
function pdp_atc(form) {
	
	// console.log( 'manual', manual );
	// console.log( '?', (manual) ? true : false )
	
	if(jQuery(form).hasClass('manual')) {
		return true;
	}
	
	// console.log( `pdp_atc()` );
	// console.log( `e`, e );
	// console.log( `form`, form );
	
	// pause ATC button
	jQuery(form).find('[data-pdp-atc]').prop('disabled', true);
	jQuery(form).find('[data-pdp-atc]').text('ADDING...');
	
	// pause mimic ATC buttons
	jQuery('[data-atc-mimic]').prop('disabled', true);
	jQuery('[data-atc-mimic] > .active-cta').text('ADDING...');
	
	// console.log( 'serialize' );
	// console.log( decodeURI(jQuery(form).serialize()).replaceAll('&', "\n&") );
	
	// ****************************** //

	var productdata = jQuery(form).serializeJSON();
	// console.log( `~~ [RAW] productdata`, productdata );
	// console.log( `~~ jQuery(form).find('.product-form--qty--input--field').data('multiplier')`, jQuery(form).find('.product-form--qty--input--field').data('multiplier') );

	if(jQuery(form).find('.product-form--qty--input--field').data('multiplier')) {
		// console.log( `~~ QTY HAS MULTIPLIER` )
		// console.log( `~~ productdata.quantity`, productdata.quantity )
		// console.log( `~~ jQuery(form).find('.product-form--qty--input--field').data('multiplier')`, jQuery(form).find('.product-form--qty--input--field').data('multiplier') )
		productdata.quantity = parseInt(productdata.quantity) * parseInt(jQuery(form).find('.product-form--qty--input--field').data('multiplier'));
	}
	else {
		// console.log( `~~ NO MULTIPLIER ON QTY` )
	}
	// console.log( `~~ [UPDATED] productdata`, productdata );
	
	var p_atc_source_placement = '';
	var p_atc_source_type = '';
	var p_atc_source_value = '';
	
	if(productdata.hasOwnProperty('properties')) {
		if(productdata.properties.hasOwnProperty('_atc_source_placement')) {
			p_atc_source_placement = productdata.properties['_atc_source_placement'];
		}
		if(productdata.properties.hasOwnProperty('_atc_source_type')) {
			p_atc_source_type = productdata.properties['_atc_source_type'];
		}
		if(productdata.properties.hasOwnProperty('_atc_source_value')) {
			p_atc_source_value = productdata.properties['_atc_source_value'];
		}
	}

	// ****************************** //

	var atcdata = {
		'items': []
	};

	if(jQuery(form).find('input[name="addon_paid_pump"]').length > 0) {
		if(jQuery(form).find('input[name="addon_paid_pump"]').is(':checked')) {
			var addon_paid_pump_qty_pump = parseInt(jQuery(form).find('input[name="addon_paid_pump"]').val());
			var addon_paid_pump_qty_multiplier = parseInt(jQuery(form).find('[data-pdp-qty]').val());
			var addon_paid_pump_qty = addon_paid_pump_qty_pump * addon_paid_pump_qty_multiplier;
			atcdata.items.push({
				'id': jQuery(form).find('input[name="addon_paid_pump"]').data('variant-id'),
				'quantity': addon_paid_pump_qty,
				'properties': {
					'_atc_source_placement': p_atc_source_placement,
					'_atc_source_type': p_atc_source_type,
					'_atc_source_value': p_atc_source_value
				}
			});
		}
	}
	
	if(jQuery(form).find('input[name="addon_product"]').length > 0) {
		jQuery(form).find('input[name="addon_product"]').each(function() {
			if(jQuery(this).is(':checked')) {
				var addon_product_qty = parseInt(jQuery(this).val());
				var addon_product_data = {
					'id': jQuery(form).find('input[name="addon_product"]').data('variant-id'),
					'quantity': addon_product_qty,
					'properties': {
						'_atc_source_placement': p_atc_source_placement,
						'_atc_source_type': p_atc_source_type,
						'_atc_source_value': p_atc_source_value
					}
				};
				if(jQuery(this).data('selling-plan')) {
					addon_product_data.selling_plan = jQuery(this).data('selling-plan');
				}
				atcdata.items.push(addon_product_data);
			}
		});
	}

	// add form product *last*
	atcdata.items.push(productdata);
	
	// bundled section rendering
	var bsr_sections = false;
	if(jQuery(form).find('input[name="bsr"]').length > 0) {
		bsr_sections = jQuery(form).find('input[name="bsr"]').val();
	}

	try {
		// AJAX add to cart
		jQuery.ajax({
			type: 'POST',
			data: atcdata,
			url: '/cart/add.js',
			dataType: 'json',
			context: this // set value of var `this` within callback functions (always, done, fail) to scope of parent
		}).always(function() {
			// console.log( 'AJAX always' );
			// console.log( 'this', this );
			// console.log( 'form', form );
			
			// resume ATC button
			// (and mimic ATC buttons)
			if(jQuery(form).find('[data-pdp-atc]').data('label-active') == 'subx') {
				jQuery(form).find('[data-pdp-atc]').text(jQuery(form).find('[data-pdp-atc]').data('label-subx'));
				jQuery('[data-atc-mimic] > .active-cta').text(jQuery(form).find('[data-pdp-atc]').data('label-subx'));
			}
			else {
				jQuery(form).find('[data-pdp-atc]').text(jQuery(form).find('[data-pdp-atc]').data('label-default'));
				jQuery('[data-atc-mimic] > .active-cta').text(jQuery(form).find('[data-pdp-atc]').data('label-default'));
			}
			jQuery(form).find('[data-pdp-atc]').prop('disabled', false);
			jQuery('[data-atc-mimic]').prop('disabled', false);
		}).done(function(r) {
			// success
			console.log( 'AJAX add to cart success.', r );
			// if member + adding free gift, disable button
			if(jQuery('#mqg').length > 0) {
				// alert('is mqg product: disable ATC buttons');
				// main product form: add to cart button
				jQuery('[data-pdp-atc]').text('GIFT REDEEMED');
				jQuery('[data-pdp-atc]').prop('disabled', true);
				// mimic buttons
				jQuery('[data-atc-mimic]').find('.active-cta').text('GIFT REDEEMED');
				jQuery('[data-atc-mimic]').find('.active-price').html(`<span class="active-pay-price" data-pdp-form-price-actual>` + jQuery('[data-pdp-form-price-compareat]').data('orig') + `</span>`);
				jQuery('[data-atc-mimic]').prop('disabled', true);
				// mimic links
				jQuery('[data-atc-mimic-link]').html(`<span class="pdp-stickycta-button-text">GIFT REDEEMED</span>`);
				jQuery('[data-atc-mimic-link]').removeAttr('onclick');
				jQuery('[data-atc-mimic-link]').addClass('disabled');
			}
			// add to cart source attribution line item properties - change all values for this product
			var product_id = r.items[0].product_id;
			var new_source_type = r.items[0].properties['_atc_source_type'];
			var new_source_value = r.items[0].properties['_atc_source_value'];
			var new_source_placement = r.items[0].properties['_atc_source_placement'];
			console.log(`Setting ATC source line item properties for product ID: ` + product_id, { new_source_type: new_source_type, new_source_value: new_source_value, new_source_placement: new_source_placement });
			jQuery('.product-id-' + product_id + '[name="properties[_atc_source_type]"]').val(new_source_type);
			jQuery('.product-id-' + product_id + '[name="properties[_atc_source_value]"]').val(new_source_value);
			jQuery('.product-id-' + product_id + '[name="properties[_atc_source_placement]"]').val(new_source_placement);
			jQuery('#product_form_' + product_id).find('[name="properties[_atc_source_placement]"]').addClass('revised');
			// bundled section rendering
			if(bsr_sections) {
				bsr(bsr_sections);
			}
		}).fail(function(err) {
			// error
			console.warn('AJAX error. Submitting manually.');
			console.warn(err);
			// manual form submit
			// jQuery(form).addClass('manual');
			// jQuery(form).submit();
		});
		return false;
	}
	catch(err) {
		console.warn('AJAX execution failed. Submitting manually.');
		console.warn(err);
		return true;
	}
}

function open_shipping_modal() {

	let modal = $('#shippingModal');

	let btn = $('.shippingModalLink');

	let close = $('.modal-close');

	btn.click(function() {
	  	modal.css('display','block');
	})

	close.click(function() {
	  	modal.css('display','none');
	})

	$(window).click(function(event) {
	  	if (event.target == modal) {
	    	modal.css('display','none');
	  	}
	})
}

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //

function pdp_3bottles(input, form) {
	// console.log( `~~ pdp_3bottles(input, form)`, input, form );
	// console.log( `~~ jQuery(form).find('.product-form--qty--input--field')`, jQuery(form).find('.product-form--qty--input--field') );
	// check 'onetime'
	jQuery(form).find('[data-purchase-type-onetime]').prop('checked', true).trigger('onchange');
	// if "3 bottles" chosen
	if(input.value == 3) {
		// hide onetime/subx options
		jQuery(form).find('.product-form--subx').addClass('hide');
		// show faux price options
		jQuery(form).find('.po-3bottles-fauxprice').removeClass('hide');
		// set flag to multiply qty by 3
		jQuery(form).find('.product-form--qty--input--field').data('multiplier', 3);
	}
	// if "1 bottle" chosen
	else {
		// hide faux price options
		jQuery(form).find('.po-3bottles-fauxprice').addClass('hide');
		// show onetime/subx options
		jQuery(form).find('.product-form--subx').removeClass('hide');
		// remove flag to multiply qty
		jQuery(form).find('.product-form--qty--input--field').removeData('multiplier');
	}
	// console.log( `~~ jQuery(form).find('.product-form--qty--input--field').data('multiplier')`, jQuery(form).find('.product-form--qty--input--field').data('multiplier') );
}

function pdp_3bottles_select(n) {
	if(jQuery('form.pdp-form').length > 0) {
		if(jQuery('form.pdp-form').find('input[type="radio"][name="po-3bottles"][value="' + n + '"]').length > 0) {
			jQuery('form.pdp-form').find('input[type="radio"][name="po-3bottles"][value="' + n + '"]').prop('checked', true);
			jQuery('form.pdp-form').find('input[type="radio"][name="po-3bottles"][value="' + n + '"]').trigger('onchange');
		}
	}
}

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //

const birdhouse_kitchenjournal_fetch = async (url, success, error, always) => {
	try {
		// console.log( `birdhouse_kitchenjournal_fetch()` );
		const r = await fetch('https://birdhouse.flamingoestate.io/' + url);
		const j = await r.json();
		var data = j;
		// console.log( 'data', data );
		// console.log( 'typeof data', typeof data );
		if(
			typeof data !== 'undefined'
		) {
			if(typeof success == 'function') {
				success(data);
			}
		}
		else {
			if(typeof error == 'function') {
				error(data);
			}
		}
		if(typeof always == 'function') {
			always(data);
		}
	}
	catch(e) {
		console.error('XHR failed', e);
	}
}

// ********** //

function birdhouse_kitchenjournal_render_authors_success(data) {
	// console.log( `birdhouse_kitchenjournal_render_authors_success()`, data );
	// console.log( 'this', this );
	jQuery(this).find('[data-dropzone-article-author]').each(function() {
		for(var i = 0; i < data.length; i++) {
			if(jQuery(this).data('dropzone-article-id') == data[i].shopify_id) {
				if(data[i].hasOwnProperty('recipe_author')) {
					if(typeof data[i].recipe_author == 'object') {
						if(data[i].recipe_author.hasOwnProperty('name')) {
							if(data[i].recipe_author.name) {
								// insert recipe author name
								jQuery(this).text(data[i].recipe_author.name);
								// show recipe byline
								jQuery(this).closest('[data-dropzone-article-author-container]').css('display', '');
							}
						}
					}
				}
			}
		}
	});
}

function birdhouse_kitchenjournal_render_authors_error(data) {
	// console.log( `birdhouse_kitchenjournal_render_authors_error()`, data );
	// console.log( 'this', this );
}

function birdhouse_kitchenjournal_render_authors(container) {
	// console.log( `birdhouse_kitchenjournal_render_authors()`, container );
	// console.log( jQuery(container).find('[data-dropzone-article-author-container]') );
	
	var article_ids = [];
	
	jQuery(container).find('[data-dropzone-article-author-container]').each(function() {
		if(jQuery(this).data('dropzone-article-id')) {
			article_ids.push(jQuery(this).data('dropzone-article-id'));
		}
	});
	
	// console.log( 'article_ids', article_ids );
	
	var query_string = '';
	
	for(var i = 0; i < article_ids.length; i++) {
		if(i == 0) {
			query_string += '?';
		}
		else {
			query_string += '&';
		}
		query_string += 'shopify_id=';
		query_string += article_ids[i];
	}
	
	// console.log( 'query_string', query_string );
	
	var query_url = 'recipes' + query_string;
	
	// console.log( 'query_url', query_url );
	
	birdhouse_kitchenjournal_fetch(query_url, birdhouse_kitchenjournal_render_authors_success.bind(container), birdhouse_kitchenjournal_render_authors_error.bind(container));
	
}

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //

function birdhouse_format_time(input) {
	var mins = parseInt(input);
	if(!isNaN(mins) && mins > 0) {
		if(mins > 60) {
			var hrs = mins / 60;
			hrs = Math.floor(hrs);
			var output = hrs + ' ';
			output += (hrs == 1) ? 'hour' : 'hours';
			mins = Math.round(mins / 60 % 1 * 60);
			if(mins > 0) {
				output += ' ';
				output += mins + ' ';
				output += (mins == 1) ? 'minute' : 'minutes';
			}
		}
		else {
			var output = mins + ' ';
			output += (mins == 1) ? 'minute' : 'minutes';
		}
		return output;
	}
	else {
		return false;
	}
}

function birdhouse_featured_recipes_render(r) {
	// console.log( `birdhouse_featured_recipes_render(r)`, r );
	// AUTHOR
	var author_valid = false;
	if(r.hasOwnProperty('recipe_author')) {
		if(r.recipe_author.hasOwnProperty('name')) {
			author_valid = true;
		}
	}
	// if author is present
	if(author_valid) {
		// set author
		jQuery('[data-dropzone-articleid="' + r.shopify_id + '"]').find('[data-dropzone-author]').html(r.recipe_author.name);
	}
	// if author is not present
	else {
		// remove byline
		jQuery('[data-dropzone-articleid="' + r.shopify_id + '"]').find('.featured-recipes-carousel-item-byline').remove();
	}
	// ATTRS
	var occasion_valid = false;
	if(r.hasOwnProperty('recipe_occasions')) {
		if(r.recipe_occasions.length > 0) {
			occasion_valid = true;
		}
	}
	var cooktime_valid = false;
	if(r.hasOwnProperty('time_cook')) {
		if(r.time_cook) {
			cooktime_valid = true;
		}
	}
	if(occasion_valid || cooktime_valid) {
		// OCCASION
		if(occasion_valid) {
			// set occasion
			jQuery('[data-dropzone-articleid="' + r.shopify_id + '"]').find('[data-dropzone-occassion]').html(r.recipe_occasions[0].name);
		}
		else {
			// remove occasion attr
			jQuery('[data-dropzone-articleid="' + r.shopify_id + '"]').find('[data-dropzone-occassion]').parent().remove();
		}
		// COOK TIME
		if(cooktime_valid) {
			// set cook time
			jQuery('[data-dropzone-articleid="' + r.shopify_id + '"]').find('[data-dropzone-cooktime]').html(birdhouse_format_time(r.time_cook));
		}
		else {
			// remove cook time attr
			jQuery('[data-dropzone-articleid="' + r.shopify_id + '"]').find('[data-dropzone-cooktime]').parent().remove();
		}
	}
	else {
		// remove attrs
		jQuery('[data-dropzone-articleid="' + r.shopify_id + '"]').find('.featured-recipes-carousel-item-attrs').html('');
	}
}

function birdhouse_featured_recipes(ids) {
	// console.log( `birdhouse_featured_recipes(ids)`, ids );
	// build query
	var query = '?';
	ids.forEach(function(id, i) {
		if(i != 0) {
			query += '&';
		}
		query += 'shopify_id=' + id;
	});
	// console.log( `query`, query );
	// API call
	jQuery.ajax({
		type: 'GET',
		url: 'https://birdhouse.flamingoestate.io/recipes' + query
	}).done(function(r, textStatus, jqXHR) {
		console.log( 'Birdhouse API call successful', r );
		// console.log( 'textStatus', textStatus );
		// console.log( 'jqXHR', jqXHR );
		r.forEach(function(data) {
			birdhouse_featured_recipes_render(data);
		});
	}).fail(function(e) {
		console.warn( 'Birdhouse API call failure', e );
		var res = JSON.parse(e.responseText);
		console.log( res );
		ids.forEach(function(id) {
			// remove byline
			jQuery('[data-dropzone-articleid="' + id + '"]').find('.featured-recipes-carousel-item-byline').remove();
			// remove attrs
			jQuery('[data-dropzone-articleid="' + id + '"]').find('.featured-recipes-carousel-item-attrs').html('');
		});
	});
}

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //

function legacy_cart_subx(line_item_key, selling_plan_id, original_value, original_type) {
	// console.log( `legacy_cart_subx(line_item_key, selling_plan_id)`, line_item_key, selling_plan_id );
	$legacy_cart_line = jQuery('.CartItem__Subscription .ajax-subx-dd[data-line-item-key="' + line_item_key + '"]');
	var subxOptionStr = $legacy_cart_line.data('subx-option-str');
	// if not already loading
	if(!$legacy_cart_line.hasClass('loading')) {
		// set as loading
		$legacy_cart_line.addClass('loading');
		// AJAX call
		jQuery.ajax({
			type: 'POST',
			url: '/cart/change.js',
			data: {
				id: line_item_key,
				selling_plan: selling_plan_id,
				properties: {
					'_subscriptionOption': subxOptionStr
				}
			},
			dataType: 'json'
		}).done(function(r) {
			// console.log( `>> AJAX SUCCESS`, r );
			// reload page
			window.location.reload();
		}).fail(function(e) {
			console.warn( 'ERROR', e );
			// var res = JSON.parse(e.responseText);
			// console.warn( res );
			if(original_type == 'dd') {
				// reset dd value to original value
				$legacy_cart_line.val(original_value);
			}
		}).always(function() {
			// unset loading
			$legacy_cart_line.removeClass('loading');
		});
	}
}

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //

// **************************************************************** //
// *** ALCOHOL AGE CHECK (BLOOM DATE OF BIRTH FORM) *** //
// **************************************************************** //

function padNumber(num, digits) {
	if(typeof digits == 'undefined') {
		digits = 2;
	}
	if(isNaN(num)) {
		return false;
	}
	else {
		var num_abs = Math.abs(num);
		var num_abs_str = num_abs.toString();
		var num_str_output = num_abs_str;
		if(num_abs_str.length < digits) {
			for(var i = 0; i < (digits - num_abs_str.length); i++) {
				num_str_output = '0' + num_str_output;
			}
		}
		if(num < 0) {
			num_str_output = '-' + num_str_output;
		}
		return num_str_output;
	}
}

// **************************************************************** //

function setInputFilter(textbox, inputFilter, errMsg) {
	["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop", "focusout"].forEach(function(event) {
		textbox.addEventListener(event, function(e) {
			if(inputFilter(this.value)) {
				// Accepted value
				if(["keydown", "mousedown", "focusout"].indexOf(e.type) >= 0) {
					this.classList.remove("input-error");
					this.setCustomValidity("");
				}
				this.oldValue = this.value;
				this.oldSelectionStart = this.selectionStart;
				this.oldSelectionEnd = this.selectionEnd;
			}
			else if(this.hasOwnProperty("oldValue")) {
				// Rejected value - restore the previous one
				this.classList.add("input-error");
				this.setCustomValidity(errMsg);
				this.reportValidity();
				this.value = this.oldValue;
				this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
			}
			else {
				// Rejected value - nothing to restore
				this.value = "";
			}
		});
	});
}

// **************************************************************** //

function aac_input_validate(el, field, cart) {
	["input", "change"].forEach(function(event) {
		el.addEventListener(event, function(e) {
			// disable button
			aac_disable_checkout(this.closest('.aac-cart'), cart);
			// check this input value
			if(!isNaN(parseInt(this.value))) {
				// auto proceed
				if(field == 'm') {
					if(
						(parseInt(this.value) > 1)
						||
						(this.value.length == 2)
					) {
						// console.log('~~~ AUTO-PROCEED MONTH > DAY');
						jQuery(this).closest('.aac-cart').find('[data-aac-dob-d]').focus().select();
					}
				}
				if(field == 'd') {
					if(this.value.length == 2) {
						// console.log('~~~ AUTO-PROCEED DAY > YEAR');
						jQuery(this).closest('.aac-cart').find('[data-aac-dob-y]').focus().select();
					}
				}
				// validate
				// console.log( `~~~ jQuery(this).closest('.aac-cart').find('[data-aac-dob-m]')`, jQuery(this).closest('.aac-cart').find('[data-aac-dob-m]').val() );
				var aac_m = false;
				if(!isNaN(parseInt(jQuery(this).closest('.aac-cart').find('[data-aac-dob-m]').val()))) {
					aac_m = jQuery(this).closest('.aac-cart').find('[data-aac-dob-m]').val();
				}
				var aac_d = false;
				if(!isNaN(parseInt(jQuery(this).closest('.aac-cart').find('[data-aac-dob-d]').val()))) {
					aac_d = jQuery(this).closest('.aac-cart').find('[data-aac-dob-d]').val();
				}
				var aac_y = false;
				if(!isNaN(parseInt(jQuery(this).closest('.aac-cart').find('[data-aac-dob-y]').val()))) {
					aac_y = jQuery(this).closest('.aac-cart').find('[data-aac-dob-y]').val();
				}
				// console.log( `~~~ aac_m`, aac_m );
				// console.log( `~~~ aac_d`, aac_d );
				// console.log( `~~~ aac_y`, aac_y );
				if(aac_m && aac_d && aac_y && aac_y.length == 4) {
					// console.log( `~~~ ALL PASS > CALL: aac_dob_check()` );
					// console.log( `~~~ this.closest('.aac-cart')`, this.closest('.aac-cart') );
					aac_dob_check(aac_m, aac_d, aac_y, this.closest('.aac-cart'), cart);
				}
			}
		});
	});
}

// **************************************************************** //

function aac_enable_checkout(form, cart, aac_dob) {
	// set value of Bloom cart attribute
	jQuery(form).find('[data-bloom-dob]').attr('name', 'attributes[Customer date of birth]');
	jQuery(form).find('[data-bloom-dob]').val(aac_dob);
	if(cart == 'legacy') {
		jQuery(form).find('[data-bloom-dob]').attr('form', 'cart-page-form');
	}
	// console.log( `~~~~ BLOOM DOB : ENABLED`, jQuery(form).find('[data-bloom-dob]') );
	// enable button
	if(cart == 'legacy') {
		jQuery('[data-legacy-cart-checkout-button]').attr('type', 'submit');
		jQuery('[data-legacy-cart-checkout-button]').attr('name', 'checkout');
		jQuery('[data-legacy-cart-checkout-button]').attr('form', 'cart-page-form');
		jQuery('[data-legacy-cart-checkout-button]').prop('disabled', false);
	}
	else if(cart == 'slide') {
		jQuery('#slide-cart-checkout-button').removeClass('disabled');
	}
}

function aac_disable_checkout(form, cart) {
	// disable Bloom cart attribute
	jQuery(form).find('[data-bloom-dob]').removeAttr('name');
	jQuery(form).find('[data-bloom-dob]').val('');
	if(cart == 'legacy') {
		jQuery(form).find('[data-bloom-dob]').removeAttr('form');
	}
	// console.log( `~~~~ BLOOM DOB : DISABLED`, jQuery(form).find('[data-bloom-dob]') );
	// disable button
	if(cart == 'legacy') {
		// console.log( `~~~~ ! DISABLE CHECKOUT : LEGACY !` );
		jQuery('[data-legacy-cart-checkout-button]').attr('type', 'button');
		jQuery('[data-legacy-cart-checkout-button]').removeAttr('name');
		jQuery('[data-legacy-cart-checkout-button]').removeAttr('form');
		jQuery('[data-legacy-cart-checkout-button]').prop('disabled', true);
	}
	else if(cart == 'slide') {
		jQuery('#slide-cart-checkout-button').addClass('disabled');
	}
}

// **************************************************************** //

function aac_dob_check(input_m, input_d, input_y, form, cart) {
	var dob_m = false;
	if(!isNaN(parseInt(input_m))) {
		dob_m = padNumber(input_m, 2);
	}
	var dob_d = false;
	if(!isNaN(parseInt(input_d))) {
		dob_d = padNumber(input_d, 2);
	}
	var dob_y = false;
	if(!isNaN(parseInt(input_y))) {
		dob_y = padNumber(input_y, 4);
	}
	// console.log( `~~~~ dob_m`, dob_m );
	// console.log( `~~~~ dob_d`, dob_d );
	// console.log( `~~~~ dob_y`, dob_y );
	if(dob_m && dob_d && dob_y) {
		// get today's date
		var aac_today_now = new Date();
		var aac_today_now_y = aac_today_now.getFullYear();
		var aac_today_now_m = aac_today_now.getMonth() + 1;
		var aac_today_now_d = aac_today_now.getDate();
		var aac_today = aac_today_now_y + '-' + padNumber(aac_today_now_m, 2) + '-' + padNumber(aac_today_now_d, 2);
		var aac_today_iso = aac_today + 'T00:00:00.000Z';
		var aac_today_date = new Date(aac_today_iso);
		var aac_today_timestamp = Date.parse(aac_today_date);
		// console.log( `~~~~ ------------------------------` );
		// console.log( `~~~~ aac_today_now`, aac_today_now );
		// console.log( `~~~~ aac_today_now_y`, aac_today_now_y );
		// console.log( `~~~~ aac_today_now_m`, aac_today_now_m );
		// console.log( `~~~~ aac_today_now_d`, aac_today_now_d );
		// console.log( `~~~~ *** aac_today`, aac_today );
		// console.log( `~~~~ aac_today_iso`, aac_today_iso );
		// console.log( `~~~~ aac_today_date`, aac_today_date );
		// console.log( `~~~~ *** aac_today_timestamp`, aac_today_timestamp );
		// console.log( `~~~~ ------------------------------` );
		// get over 21 date
		var aac_over21 = (aac_today_now_y - 21) + '-' + padNumber(aac_today_now_m, 2) + '-' + padNumber(aac_today_now_d, 2);
		var aac_over21_iso = aac_over21 + 'T00:00:00.000Z';
		var aac_over21_date = new Date(aac_over21_iso);
		var aac_over21_timestamp = Date.parse(aac_over21_date);
		// console.log( `~~~~ *** aac_over21`, aac_over21 );
		// console.log( `~~~~ aac_over21_iso`, aac_over21_iso );
		// console.log( `~~~~ aac_over21_date`, aac_over21_date );
		// console.log( `~~~~ *** aac_over21_timestamp`, aac_over21_timestamp );
		// console.log( `~~~~ ------------------------------` );
		// string input DOB
		var aac_dob = dob_y + '-' + dob_m + '-' + dob_d;
		var aac_dob_iso = aac_dob + 'T00:00:00.000Z';
		var aac_dob_date = new Date(aac_dob_iso);
		var aac_dob_timestamp = Date.parse(aac_dob_date);
		// console.log( `~~~~ *** aac_dob`, aac_dob );
		// console.log( `~~~~ aac_dob_iso`, aac_dob_iso );
		// console.log( `~~~~ aac_dob_date`, aac_dob_date );
		// console.log( `~~~~ *** aac_dob_timestamp`, aac_dob_timestamp );
		// console.log( `~~~~ ------------------------------` );
		// validate input DOB
		var aac_dob_valid = false;
		if(!isNaN(aac_dob_timestamp)) {
			var aac_dob_check_pieces = aac_dob_date.toISOString();
			var aac_dob_check = aac_dob_check_pieces.split('T')[0];
			if(aac_dob == aac_dob_check) {
				aac_dob_valid = true;
			}
		}
		// console.log( `~~~~ aac_dob_valid`, aac_dob_valid );
		// console.log( `~~~~ ------------------------------` );
		// check if DOB is over 21
		var aac_is_over21 = false;
		if(aac_dob_valid) {
			// console.log( `~~~~ dob timestamp valid` );
			if(aac_dob_timestamp <= aac_over21_timestamp) {
				aac_is_over21 = true;
			}
		}
		else {
			// console.warn( `~~~~ dob timestamp invalid` );
		}
		// console.log( `~~~~ aac_is_over21`, aac_is_over21 );
		// console.log( `~~~~ ------------------------------` );
		// if is over 21
		if(aac_is_over21) {
			// console.log( `~~~~ DOB IS OVER 21` );
			// console.log( `~~~~ cart`, cart );
			// hide error message
			jQuery(form).find('.aac-cart-error').removeClass('on');
			if(cart == 'slide') {
				jQuery('#ajax-cart-form').removeClass('contains-alcohol-error');
				jQuery('#ajax-cart-form').find('.form-b').removeClass('contains-alcohol-error');
			}
			// enable checkout button
			aac_enable_checkout(form, cart, aac_dob);
		}
		// if not over 21
		else {
			// console.warn( `~~~~ dob not over 21` );
			// console.warn( `~~~~ cart`, cart );
			// show error message
			jQuery(form).find('.aac-cart-error').addClass('on');
			if(cart == 'slide') {
				jQuery('#ajax-cart-form').addClass('contains-alcohol-error');
				jQuery('#ajax-cart-form').find('.form-b').addClass('contains-alcohol-error');
			}
			// disable checkout button
			aac_disable_checkout(form, cart);
		}
	}
}

// **************************************************************** //

function aac_form_focus(el, ev, strict) {
	if(strict) {
		if(ev.target !== el) {
			return false;
		}
	}
	// console.log( `aac_form_focus(el, ev, strict)`, el, ev, strict );
	var $form = jQuery(el).closest('.aac-cart');
	if($form.find('[data-aac-dob-m]').val() == '') {
		$form.find('[data-aac-dob-m]').focus().select();
	}
	else if($form.find('[data-aac-dob-d]').val() == '') {
		$form.find('[data-aac-dob-d]').focus().select();
	}
	else {
		$form.find('[data-aac-dob-y]').focus().select();
	}
}

function aac_legacy_cart_checkout_button_handler(el) {
	// console.log( `~~ jQuery('[data-legacy-cart-checkout-button]').prop('disabled')`, jQuery('[data-legacy-cart-checkout-button]').prop('disabled') );
	if(jQuery('[data-legacy-cart-checkout-button]').prop('disabled')) {
		// scroll to alcohol age check form
		// jQuery(window).scrollTo(jQuery('.aac-cart.legacy-cart'), 250, 'easeOutQuad');
		// focus in DOB form
		aac_form_focus(jQuery('.aac-cart.legacy-cart').find('.aac-cart-form').get(0), false, false);
	}
}

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //

function time_min_to_iso_8601(mins) {
	mins = parseInt(mins);
	var days = Math.floor(mins / 1440);
	mins = mins - days * 1440;
	var hours = Math.floor(mins / 60);
	mins = mins - hours * 60;
	var dur = "PT";
	if(days > 0) {
		dur += days + "D";
	}
	if(hours > 0) {
		dur += hours + "H";
	}
	dur += mins + "M"
	return dur;
}

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //

// collection infinite scroll pad fix
function infinitescroll_padfix() {
	if(!jQuery('#gscollectionbottom').find('center').html()) {
		jQuery('#gscollectionbottom').html('');
	}
}

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //

function htmlspecialchars(str) {
	return str
		.replaceAll(/&/g, '&amp;')
		.replaceAll(/"/g, '&quot;')
		.replaceAll(/'/g, '&#039;')
		.replaceAll(/</g, '&lt;')
		.replaceAll(/>/g, '&gt;')
	;
}

function json_escape(str) {
	return str
		.replaceAll(/"/g, '\\"')
		.replaceAll(/\n/g, ' ')
	;
}

function toggleCollectionFooter() {
	const $section = $('.collection-footer-description');
	const $readMore = $section.find('.collection-read-more');
	const $triggerButton = $section.find('.collection-read-more-button');
	$triggerButton.on('click', function () {
		$readMore.animate({
			height: "toggle"
		}, 300);

		if ($triggerButton.text() === "Read More") {
			$triggerButton.text('Read Less')
		} else {
			$triggerButton.text('Read More')
		}
	})
}

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //


jQuery(document).ready(function() {
	
	if(is_pdp()) {
		pdp_stickycta_scroll()
		open_shipping_modal()
	};

	// toggle collection footer
	toggleCollectionFooter();
	
	// collection infinite scroll pad fix
	/*
	if(jQuery('#gscollectionbottom').length > 0) {
		var infinitescroll_padfix_node = document.getElementById('gscollectionbottom');
		var infinitescroll_padfix_config = { attributes: true, childList: true, subtree: true };
		var infinitescroll_padfix_observer = new MutationObserver(infinitescroll_padfix);
		infinitescroll_padfix_observer.observe(infinitescroll_padfix_node, infinitescroll_padfix_config);
	}*/
	
	jQuery('.ProductItem__Link__Wrapper.Rollover:not(.RolloverOffMobile)').each(function() {
		jQuery(this).on('touchstart', function() {
			// badge css
			jQuery(this).addClass('RolloverMobile');
			// rollover image fade
			jQuery(this).find('.ProductItem__Image__Primary').stop(true, false).animate({
				opacity: 0
			}, 150, 'easeOutQuad');
		});
		jQuery(this).on('touchend', function() {
			// badge css
			jQuery(this).removeClass('RolloverMobile');
			// rollover image fade
			jQuery(this).find('.ProductItem__Image__Primary').stop(true, false).animate({
				opacity: 1
			}, 150, 'easeOutQuad');
		});
	});
	
	// **************************************************************** //
	// ON RESIZE
	// **************************************************************** //
	
	function on_resize() {
		if(is_pdp()) {
			pdp_stickycta_scroll()
		};
		
	}
	
	on_resize();
	
	jQuery(window).resize(on_resize);

	window.addEventListener('orientationchange', on_resize);
	
	// **************************************************************** //
	
});

/* MEGAMENU */

function megamenu2_toggle() {
	if(!jQuery('#root').hasClass('megamenu-open')) {
		megamenu2_open();
	}
	else {
		megamenu2_close();
	}
}

function megamenu2_open() {
	if(!jQuery('#root').hasClass('megamenu-open')) {
		body_scroll_stop();
		jQuery('#root').addClass('megamenu-open');
	}
}

function megamenu2_close() {
	if(jQuery('#root').hasClass('megamenu-open')) {
		if(screendm_megamenu() == 'mobile') {
			// clear active L1s
			jQuery('.megamenu-menu-L1.active').removeClass('active');
			// clear active L1 subs
			jQuery('.megamenu-menu-L1-sub.active').removeClass('active');
			// clear heights
			jQuery('.megamenu-menu-L1-sub').css('height', '');
		}
		body_scroll_start();
		jQuery('#root').removeClass('megamenu-open');
	}
}

// **************************************************************** //

function megamenu2_page_toggle(page) {
	console.log( `megamenu2_page_toggle(page)`, page );
	var page_id = '#mm2--L1--' + page + '--sub';
	if(!jQuery(page_id).hasClass('active')) {
		megamenu2_page_open(page);
	}
	else {
		megamenu2_page_close();
	}
}

function megamenu2_page_open(page) {
	if(screendm_megamenu() == 'mobile') {
		if(jQuery('#announcementbar').length > 0) {
			var announcementbar_h = jQuery('#announcementbar').outerHeight();
		}
		else {
			var announcementbar_h = 42;
		}
		jQuery('.megamenu-beta').scrollTo((
			(page * jQuery('.megamenu-menu-L1').first().outerHeight())
			-
			announcementbar_h
			-
			4
		), 200);
		// animate close all open
		jQuery('.megamenu-menu-L1-sub.active').stop(true, false).animate({
			height: '0px'
		}, 250, 'easeOutQuad', function() {
			jQuery(this).css('height', '');
			jQuery(this).removeClass('active');
		});
		// animate open
		jQuery('#mm2--L1--' + page + '--sub').css('height', 'auto');
		var full_open_h = jQuery('#mm2--L1--' + page + '--sub').outerHeight();
		// console.log( `full_open_h`, full_open_h );
		jQuery('#mm2--L1--' + page + '--sub').css('height', '0px');
		jQuery('#mm2--L1--' + page + '--sub').stop(true, false).animate({
			height: full_open_h + 'px'
		}, 250, 'easeOutQuad', function() {
			// jQuery('#mm2--L1--' + page + '--sub').css('height', '');
		});
	}
	else {
	}
	
	// clear 'page open' mark
	jQuery('.megamenu').removeData('L1-sub-active');
	// close all pages
	jQuery('.megamenu-menu-L1-sub').removeClass('active');
	// open specified page
	jQuery('#mm2--L1--' + page + '--sub').addClass('active');
	// mark page open
	jQuery('.megamenu').data('L1-sub-active', page);
	// deactivate all L1 links
	jQuery('.megamenu-menu-L1').removeClass('active');
	// activate L1 link
	jQuery('#mm2--L1--' + page).addClass('active');
	// On any menu open, close the search bar
	jQuery('body').removeClass('open-search');
}

function megamenu2_page_close() {
	// console.log( `megamenu2_page_close()` );
	// clear 'page open' mark
	jQuery('.megamenu').removeData('L1-sub-active');
	// deactivate all L1 links
	jQuery('.megamenu-menu-L1').removeClass('active');
	// if mobile...
	if(screendm_megamenu() == 'mobile') {
		// animate close
		jQuery('.megamenu-menu-L1-sub.active').stop(true, false).animate({
			height: '0px'
		}, 250, 'easeOutQuad', function() {
			jQuery(this).css('height', '');
			jQuery(this).removeClass('active');
		});
	}
	// if desktop...
	else {
		// close all pages
		jQuery('.megamenu-menu-L1-sub.active').removeClass('active');
	}
}

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //

function collection_meta_control_dropdown(select) {
	// console.log( `~~ collection_meta_control_dropdown()`, select);
	// console.log( `~~ select.value`, select.value);
	window.location.href = select.value;
}

// ********** //

function collection_meta_control_dropdown_toggle(el) {
	// console.log( `~~ collection_meta_control_dropdown_toggle()`, el);
	// if closed
	if(!jQuery(el).hasClass('cmcs-open')) {
		// set open
		jQuery(el).addClass('cmcs-open');
		// show blocker
		jQuery(el).parent().parent().find('.collection-meta-control-dropdown-menu-blocker').addClass('cmcs-open');
	}
	// if open
	else {
		// set closed
		jQuery(el).removeClass('cmcs-open');
		// console.log( `~~ removed class: .cmcs-open`, el );
		// hide blocker
		jQuery(el).parent().parent().find('.collection-meta-control-dropdown-menu-blocker').removeClass('cmcs-open');
	}
}

// ********** //

function collection_meta_control_dropdown_blocker(blocker) {
	// close dropdown
	collection_meta_control_dropdown_toggle(jQuery(blocker).parent().find('.collection-meta-control-dropdown.cmcs-open').get(0));
	// hide blocker
	jQuery(blocker).removeClass('cmcs-open');
}

// ********** //

function collection_meta_nav_load_scroll(container) {
	// console.log( `~~ collection_meta_nav_load_scroll(container)`, container );
	if(jQuery(container).find('.collection-meta-control-nav-items').find('.collection-meta-control-nav-item.selected').length > 0) {
		var containerW = jQuery(container).find('.collection-meta-control-nav-items').outerWidth();
		// console.log( `~~ containerW`, containerW );
		// console.log( `~~ jQuery(container)`, jQuery(container) );
		var selectedOffset = (
			jQuery(container).find('.collection-meta-control-nav-items').find('.collection-meta-control-nav-item.selected').offset().left
			+
			jQuery(container).find('.collection-meta-control-nav-items').scrollLeft()
		);
		// console.log( `~~ selectedOffset`, selectedOffset );
		var scrollX_set = selectedOffset - 15;
		// console.log( `~~ scrollX_set`, scrollX_set );
		var scrollX = scrollX_set;
		if(window.outerWidth > 640) {
			// scrollX -= parseInt(jQuery('.collection-meta').css('padding-left'));
			scrollX -= jQuery('.collection-meta-control-nav-items').offset().left;
			scrollX -= 8;
		}
		// console.log( `~~ scrollX`, scrollX );
		jQuery(container).find('.collection-meta-control-nav-items').scrollLeft(scrollX);
	}
}

// ********** //

function collection_meta_sticky_on() {
	if(jQuery('.collection-meta-control').length > 0) {
		// activate sticky
		jQuery('.collection-meta-control').addClass('sticky');
		// activate sticky spacer
		jQuery('.collection-meta-control-stickyspacer').addClass('active');
		// hide megamenu box shadow
		jQuery('.megamenu').addClass('hide');
	}
}

function collection_meta_sticky_off() {
	if(jQuery('.collection-meta-control').length > 0) {
		// deactivate sticky
		jQuery('.collection-meta-control').removeClass('sticky');
		// deactivate sticky spacer
		jQuery('.collection-meta-control-stickyspacer').removeClass('active');
		// reset megamenu box shadow
		jQuery('.megamenu').removeClass('hide');
	}
}

function collection_meta_sticky() {
	var stickyStart = jQuery('.collection-meta-control-stickyspacer').offset().top - jQuery('.megamenu').outerHeight();
	// var stickyEnd = jQuery('.collection-meta-control-stickyspacer').offset().top - jQuery('.megamenu').outerHeight() +
	var stickyEnd = jQuery('#body').outerHeight() - (jQuery('.megamenu').outerHeight() * 2);
	// console.log( `~~ collection_meta_sticky()`, stickyStart, stickyEnd );
	if(window.scrollY < stickyStart) {
		collection_meta_sticky_off();
	}
	else if(window.scrollY >= stickyStart && window.scrollY <= stickyEnd) {
		collection_meta_sticky_on();
	}
	else if(window.scrollY > stickyEnd) {
		collection_meta_sticky_off();
	}
}

// ********** //

function collection_meta_scroll(e) {
	var el = e.currentTarget;
	// console.log( `~~ collection_meta_scroll(e)`, e );
	var scrollPos = Math.ceil(el.scrollLeft);
	var scrollMax = el.scrollWidth - el.offsetWidth;
	// console.log( `~~ scrollPos`, scrollPos );
	// console.log( `~~ scrollMax`, scrollMax );
	// console.log( `~~ el.scrollLeft [vs] el.parentElement.offsetWidth`, el.scrollLeft + ' [vs] ' + el.parentElement.offsetWidth );
	
	// scroll blocker L
	if(scrollPos <= 0) {
		// hide blocker L
		jQuery('.collection-meta-control-nav-items-container').find('.collection-meta-control-nav-scrollblocker-l').removeClass('active');
	}
	else {
		// show blocker L
		jQuery('.collection-meta-control-nav-items-container').find('.collection-meta-control-nav-scrollblocker-l').addClass('active');
	}
	// scroll blocker R
	if(scrollPos >= scrollMax) {
		// hide blocker R
		jQuery('.collection-meta-control-nav-items-container').find('.collection-meta-control-nav-scrollblocker-r').removeClass('active');
	}
	else {
		// show blocker R
		jQuery('.collection-meta-control-nav-items-container').find('.collection-meta-control-nav-scrollblocker-r').addClass('active');
	}
}

function collection_meta_nav_render() {
	var children_w = 0;
	jQuery('.collection-meta-control-nav-items').children().each(function() {
		children_w += jQuery(this).outerWidth(true);
		// console.log( `~~ this / width`, jQuery(this), jQuery(this).outerWidth() );
	});
	children_w = parseInt(children_w);
	// console.log( `~~ children_w`, children_w );
	var colA = 0;
	if(jQuery('.collection-meta-control-spacer').length > 0) {
		colA = parseInt(jQuery('.collection-meta-control-spacer').outerWidth());
	}
	var colB = 0;
	if(jQuery('.collection-meta-control-dropdowns').length > 0) {
		colB = parseInt(jQuery('.collection-meta-control-dropdowns').outerWidth());
	}
	var parent_w = (
		jQuery('.collection-meta-control-container').outerWidth()
		-
		colA
		-
		colB
	);
	parent_w = parseInt(parent_w);
	// console.log( `~~ parent_w`, parent_w );
	if(children_w > parent_w) {
		// text align: left
		// console.log( `~~ CUT OFF` );
		jQuery('.collection-meta-control-nav-items').css('justify-content', 'left');
	}
	else {
		// text align: center
		// console.log( `~~ NOT CUT OFF` );
		jQuery('.collection-meta-control-nav-items').css('justify-content', '');
	}
	collection_meta_scroll({
		currentTarget: jQuery('.collection-meta-control-nav-items').get(0)
	});
}

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //

// GEOLOCATION TARGETED POP-UP

function geopopup_open() {
	jQuery('#geopopup').addClass('active');
	jQuery('#geopopup-blocker').addClass('active');
}

function geopopup_close() {
	jQuery('#geopopup').removeClass('active');
	jQuery('#geopopup-blocker').removeClass('active');
}

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //

function cloudflare_load(videoid, el) {
	jQuery.ajax({
		url: 'https://api.cloudflare.com/client/v4/accounts/9a750c1b972db0bf50025c9927ab831d/stream/' + videoid,
		headers: {
			"Authorization": "Bearer w3ZI8ot1eZz1vR_fwfHTrgsWGJlU7b1GG-ouOCSl"
		}
	})
	.done(res => {
		var aspectratio = res.result.input.height / res.result.input.width * 100;
		jQuery(el).html(`<div style="position: relative; padding-top: ` + aspectratio + `%;"><iframe src="https://iframe.videodelivery.net/` + videoid + `?muted=true&preload=true&loop=true&autoplay=true&poster=https%3A%2F%2Fvideodelivery.net%2F` + videoid + `%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600&controls=false" style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%;" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" allowfullscreen="true"></iframe></div>`);
		jQuery(el).addClass('loaded');
		console.log( `[CLOUDFLARE] video loaded: ` + videoid, el );
	})
	.fail(res => {
		jQuery(el).html(`<iframe src="https://iframe.videodelivery.net/` + videoid + `?muted=true&preload=true&loop=true&autoplay=true&poster=https%3A%2F%2Fvideodelivery.net%2F` + videoid + `%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600&controls=false" style="border: none;" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" allowfullscreen="true"></iframe>`);
		jQuery(el).addClass('error');
		console.warn( `[CLOUDFLARE] error`, res );
		console.warn( `[CLOUDFLARE] video fallback loaded: ` + videoid, el );
	})
}

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //

// *** MEMBERSHIP QUARTERLY GIFT - ADD TO CART *** //

function cart_mqg_add(btn, cart) {
	if(!jQuery(btn).hasClass('working')) {
		jQuery(btn).addClass('working');
		var data = {
			items: [
				{
					id: jQuery(btn).data('membership-gift-variant-id'),
					quantity: 1
				}
			]
		};
		console.log( `cart_mqg_add() > data`, data );
		jQuery.ajax({
			type: 'POST',
			data: data,
			url: '/cart/add.js',
			dataType: 'json'
		}).done(function(r) {
			// console.log( `~~ cart_mqg_add() > success!`, r );
			// hide quarterly gift add to cart section
			jQuery(btn).closest('.cart-mqg').remove();
			if(cart == 'legacy') {
				// reload page
				location.reload();
			}
		}).fail(function(e) {
			// console.warn( `~~ cart_mqg_add() > fail!`, e );
			// re-enable atc button
			jQuery(btn).removeClass('working');
		}).always(function() {
		});
	}
}

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //

// *** BUNDLED SECTION RENDERING - EXECUTE SCRIPTS IN REPLACED HTML *** //

function runScripts(element) {
	// console.log( `~~~ runScripts(element)`, element );

	var scripts = element.querySelectorAll('script');

	// console.log( `~~~ scripts`, scripts );

	for(var i = 0; i < scripts.length; i++) {
		if(
			scripts[i].getAttribute('type') != 'text/template'
			&&
			scripts[i].getAttribute('type') != 'application/json'
		) {
			var script = scripts[i];
			var scriptParent = script.parentNode;
			var newScript = document.createElement('script');
			newScript.text = script.text;

			// console.log( `~~~ ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ ~~~` );
			// console.log( `~~~ script`, script);
			// console.log( `~~~ scriptParent`, scriptParent);
			// console.log( `~~~ newScript`, newScript);

			// jQuery(newScript).insertBefore(script);
			// jQuery(script).remove();
			try {
				scriptParent.removeChild(script);
				scriptParent.appendChild(newScript);
			}
			catch(e) {
				console.warn('`runScripts()` - Unable to append new script', newScript, e);
			}
		}
	}
}

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //

function product_tile_mobile_swiper(el) {
	// console.log( `product_tile_mobile_swiper(el)`, el );
	const swiper = new Swiper(el, {
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true,
		pagination: {
			el: '.swiper-pagination',
			clickable: false
		}
	});
	swiper.on('activeIndexChange', function() {
		// console.log( `~~ this`, this );
		if(this.activeIndex % 2 == 0) {
			// even - alt light badge
			el.closest('.ProductItem__Link__Wrapper').classList.add('BadgesAlt');
		}
		else {
			// odd - regular dark badge
			el.closest('.ProductItem__Link__Wrapper').classList.remove('BadgesAlt');
		}
	});
}

jQuery(document).ready(function() {

	announcementbar_cycle();

	/*
	** MEGAMENU V2 **
	**
	$('#shopify-section-megamenu-v2').find('.megamenu-menu-L1:not(.single)').on('mouseenter', function() {
		if(screendm_megamenu() == 'desktop') {
			console.log( 'desktop', `jQuery('.megamenu-menu-L1').on('mouseenter')` );
			console.log( 'this', this );
			console.log( 'jQuery(this)', jQuery(this) );
			megamenu2_page_open(jQuery(this).data('index'));
			megamenu2_open();
		}
	});

	$('#shopify-section-megamenu-v2').on('mouseleave', function() {
		if(screendm_megamenu() == 'desktop') {
			if(jQuery('#root').hasClass('megamenu-open')) {
				megamenu2_page_close();
				megamenu2_close();
			}
		}
	});
	$('#shopify-section-megamenu-v2').find('.megamenu-hamburger').on('click', function() {
		if(screendm_megamenu() == 'mobile') {
			megamenu2_toggle();
		}
	});
	$('#shopify-section-megamenu-v2').find('.megamenu-menu-L1:not(.single)').on('click', function(e) {
		if(screendm_megamenu() == 'mobile') {
			e.preventDefault();
			megamenu2_page_toggle(jQuery(this).data('index'));
		}
	});
	*/
	
	// **************************************************************** //
	// ON SCROLL
	// **************************************************************** //

	// Add class to body when scrolling

	function window_scroll() {
		var targetDiv = $('body');
		var windowpos = $(window).scrollTop();
		var annoucementBarHeight = 0;
		if(jQuery('#announcementbar').length > 0) {
			annoucementBarHeight = jQuery('#announcementbar').outerHeight();
		}
		// console.log( `~~ annoucementBarHeight`, annoucementBarHeight );
		if(windowpos > annoucementBarHeight) {
			targetDiv.addClass('scrolled');
		}
		else {
			targetDiv.removeClass('scrolled');
		}
		if(windowpos > 1) {
			targetDiv.addClass('immediateScroll');
		}
		else {
			targetDiv.removeClass('immediateScroll');
		}
		// calculate distance scrolled through annoucement bar
		if(annoucementBarHeight > 0 && windowpos < annoucementBarHeight) {
			// "scroll through announcement bar"
			targetDiv.css('--stab', windowpos + 'px');
		}
		else {
			targetDiv.css('--stab', annoucementBarHeight + 'px');
		}
	}

	$(window).scroll(window_scroll);

	window_scroll();

	// **************************************************************** //
	// ON RESIZE
	// **************************************************************** //
	
	function on_resize() {
		// calculate window height
		jQuery('body').css('--wh', jQuery(window).outerHeight() + 'px');
	}
	
	on_resize();
	
	jQuery(window).resize(on_resize);
	window.addEventListener('orientationchange', on_resize);

	// **************************************************************** //
	// Collapsed megamenu search bar
	// **************************************************************** //

	/*
	** MEGAMENU V2 **
	**
	$('.megamenu-search-link').on('click', function(e) {
		// Close megamenu on search open
		megamenu2_page_close();
		megamenu2_close();
		// Open search
		$('body').toggleClass('open-search');
		// Focus in search field
		$('.megamenu-search-input-full').focus();
		
		// (If PDP) Restructure sticky CTA bar
		if(is_pdp()) {
			pdp_stickycta_scroll();
		}
		
		e.preventDefault();
	});

	$('.megamenu-search-close').on('click', function(e) {
		// Close search
		$('body').removeClass('open-search');
		
		// (If PDP) Restructure sticky CTA bar
		if(is_pdp()) {
			pdp_stickycta_scroll();
		}
		
		e.preventDefault();
	});
	*/

	// **************************************************************** //
	// Dynamically center nav items around logo
	// **************************************************************** //

	/*
	** MEGAMENU V2 **
	**
	(function() {
		let menuTextItemsAll = $('.megamenu-menu-L1-text');
		let menuTextItemsLeft = menuTextItemsAll.slice(0, menuTextItemsAll.length / 2);
		let menuTextItemsRight = menuTextItemsAll.slice(menuTextItemsAll.length / 2);
		let charactersOffset = menuTextItemsRight.text().length - menuTextItemsLeft.text().length;
	})();
	*/
	
});

/* custom.js appended here  */

 $(function() {
  // Adds scroll class to header for sticky header
  //var headerSettings = JSON.parse($("#section-header").attr('data-section-settings'));
  //if (headerSettings['isSticky']) {
    // Hide Header on on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = 0;
    var headerHeight = $('#section-header').outerHeight();

    $(window).scroll(function(event){
      didScroll = true;
    });

    setInterval(function() {
      if (didScroll) {
        hasScrolled();
        didScroll = false;
      }
    }, 250);

    function hasScrolled() {
      var st = $(this).scrollTop();

      // Make sure they scroll more than delta
      if(Math.abs(lastScrollTop - st) <= delta)
        return;

      // If they scrolled down and are past the navbar, add class .nav-up.
      // This is necessary so you never see what is "behind" the navbar.
      if (st > lastScrollTop && st > navbarHeight){
        // Scroll Down
        $('#section-header').removeClass('Header--scrolling-up').addClass('Header--scrolling-down');
        $("#main").css("padding-top", "0px");
      } else {
        
        if(st > $(window).height()) {
          $(".shopify-section--slideshow").parent().css("margin-top", -95);
          $("#main").css("padding-top", headerHeight);
          $('#section-header').removeClass('Header--scrolling-down').addClass('Header--scrolling-up');
        } else {
          $("#main").css("padding-top", "0px");
          $('#section-header').removeClass('Header--scrolling-up');
        }
      }

      lastScrollTop = st;
    }
  
  // Hide annoucement bar when X is clicked
  $("#shopify-section-announcement").on("click", function() {
	$(this).hide();
  });
  
  // Hide annoucement bar AND search icon when mobile hamburger is clicked
  $('[aria-label="Open navigation"]').on("click", function() {
	$("#shopify-section-header").addClass('onTop');
    $("#shopify-section-announcement").hide();
    $('[data-action="toggle-search"]').hide();
    $(this).hide();
    $('[aria-label="Close navigation"]').show();
    $(".Header").addClass("Header--menu-open");
  });
  
  // Show hamburger/hide X when mobile menu closed
  $('[aria-label="Close navigation"]').on("click", function() {
    $(this).hide();
    $('[aria-label="Open navigation"]').show();
    $('[data-action="toggle-search"]').show();
    $(".Header").removeClass("Header--menu-open");
  });
  
  // Change z-index on header when cart drawer is open
  $('[aria-label="Open cart"]').on("click", function() {
    $("#shopify-section-header").removeClass("onTop");
  });
  
  $('[aria-label="Close cart"]').on("click", function() {
    $("#shopify-section-header").addClass("onTop");
  });
  
  // Change annoucement bar color when navigation is opened
  $('.Header:not(.Header--transparent) .HorizontalList__Item[aria-haspopup]').on({
    mouseenter: function () {
			// $(".Header").addClass("Header--menu-open");
      $("#section-announcement").addClass("goPink");
    }
  });
  
	/* *** ZB - START *** */
	
	// add class `.Header--menu-open` regardless of if it also has class `.Header--transparent`
	$('.Header .HorizontalList__Item[aria-haspopup]').on({
    mouseenter: function () {
			$(".Header").addClass("Header--menu-open");
    }
  });
	
	/* *** ZB - END *** */
	
  // // Open up the Details tab on page load
  $('.pretoggled[data-action="toggle-collapsible"]').click();
  
  // On page load check to see if the gift option box is checked and hide note input if not
  if (!$("#properties-gift").is(":checked")) {
    $("#cart-note").hide();
  }
  
  // Show/hide note box if gift checkbox is checked
  $("#properties-gift").change(function(){
    if ($(this).is(':checked')) {
      $("#cart-note").show();
      $("#count1").addClass("count-show");
    } else {
      $("#cart-note").hide();
      $("#count1").removeClass("count-show");
    }
  });
  
  // Add grid item product to cart drawder
  document.querySelectorAll('form[data-ajax-cart="true"]').forEach((ele) => {
    ele.addEventListener('submit', (event) => {
      event.preventDefault();
      // add code to items using AJAX
      let formData = new FormData(ele);
      // making AJAX call to API using form data
      fetch('/cart/add.js', {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      }).then(function (e) {
        if (e.ok && e.status == 200) {
          ele.dispatchEvent(new CustomEvent('product:added', {
            bubbles: !0,
            detail: {}
          }));
        }
      });
    });
  });
});

$(function() {
	$("#accordion > h3").on("click", function(e) {
		$(this).next().slideToggle(function(e) {
			if ($(this).is(":visible")) {
				$(this).addClass("ui-accordion-content-active")
				.prev().toggleClass("ui-corner-all ui-corner-top").addClass("ui-accordion-header-active ui-state-active")
				.children(".ui-accordion-header-icon").toggleClass("ui-icon-triangle-1-e ui-icon-triangle-1-s");
			}
			else {
				$(this).removeClass("ui-accordion-content-active")
				.prev().toggleClass("ui-corner-all ui-corner-top").removeClass("ui-accordion-header-active ui-state-active")
				.children(".ui-accordion-header-icon").toggleClass("ui-icon-triangle-1-e ui-icon-triangle-1-s");
			}
		});
	})
	.hover(function(e) { $(this).toggleClass("ui-state-hover"); });
})


$(document).ready(function() {

	$(".toggle-title").click(function() {
		// if this accordion closed
		if($(this).hasClass('active')) {
			this_index = $(this).parent().index();
			console.log( `this_index`, this_index );
			// close all other accordions
			$(this).parent().parent().children().each(function(i) {
				if(i != this_index) {
					// if open
					if(!$(this).find('.toggle-title').hasClass('active')) {
						// close other accordion
						$(this).find('.toggle-content').slideUp('normal');
						$(this).find('.toggle-title').addClass('active');
					}
				}
			});
			// open this accordion
			$(this).next('.toggle-content').slideDown('normal');
			$(this).removeClass('active');
		}
		// if this accordion open
		else {
			// close this accordion
			$(this).next('.toggle-content').slideUp('normal');
			$(this).addClass('active');
		}
	});

	// Panels (product tabs) with these titles will be open by default; use lowercase to prevent case mismatch
	let openPanelsTitles = [];

	// Loop through each panel title and check if its content is in the array of open titles
	$('.toggle-title').each(function() {
		if (openPanelsTitles.includes( $(this).text().trim().toLowerCase() )) {
			$(this).trigger('click');
		}
	});

	/*
	$('.ts-sample-cart-box').click(function(){
		$('.ts-sample-cart-box').toggleClass('no-border');
		$('.sample_pro').toggleClass('product-show');
	});
	*/

	$('#coupen_submit').click(function(){
		var discountStored = $('#coupen_code').val();
		if(discountStored) {
			window.location.href = "/checkout?discount="+discountStored;
		}
	});

	$('.ts-sample-cart-box').click(function(){
		$('.ts-sample-cart-box').toggleClass('no-border');
		$('.ts-sample-creward-cart-box').removeClass('no-border');
		$('.my-cart-login-form').removeClass('form-show-ts');
		$('.sample_pro').toggleClass('product-show');
	});

	$('.ts-sample-creward-cart-box').click(function(){
		$('.ts-sample-creward-cart-box').toggleClass('no-border');
		$('.sample_pro').removeClass('product-show');
		$('.ts-sample-cart-box').removeClass('no-border');
		$('.my-cart-login-form').toggleClass('form-show-ts');
	});

	$('textarea').keyup(function() {
		var characterCount = $(this).val().length,
			current_count = $('#current_count'),
			maximum_count = $('#maximum_count'),
			count = $('#count');
		current_count.text(characterCount);
	});

	$('.Form__ItemHelp').click(function(){
		$('.cart-forgot-password-desktop').toggleClass('show-it');
	});

	$('.mobile-help').click(function(){
		$('.cart-forgot-password-mobile').toggleClass('show-it');
	});

	$('#cart-modal-btn').click(function(e) {
		e.preventDefault();
		$('#cart-modal').toggleClass('modal-show');
		$('body').addClass('modal-body');
	});

	$('.close-popup').click(function(){
		$('#cart-modal').removeClass('modal-show');
		$('body').removeClass('modal-body');
	});
	$('.add-pump-cb').change(function() {
		const $this = $(this);
		var pro_id = $this.data('pro-id');
		var line_id = $this.data('line-id');
		if($this.prop("checked") == true){
			$('#add-pump-val-'+pro_id).val('Yes');
		} else {
			$('#add-pump-val-'+pro_id).val('No');
		}
		var inputData = $('.propContainer-'+pro_id).find('.propLine');

		var data = {
			id: line_id,
			properties: ''
		}
		var tempProperties = {}
		inputData.each(function(index, el) {
			tempProperties[$(el).data('name')] = $(el).val();
		});
		data.properties = tempProperties;

		setTimeout(function(){
			jQuery.ajax({
				url: '/cart/change.js',
				dataType: 'json',
				data: data
			}).done(function() {
				window.location.reload()
			})
		}, 300);
	});

});